export default {
    data: [{
            name: "赵",
            py: "zhào",
            bihua: "9画",
            wx: "火",
            source: "赵姓主要源自嬴姓，造父为赵氏的始祖。在《百家姓》中排第一，在历史长河中赵姓人才辈出，意蕴深远。",
            py2: "zhao"
        },
        {
            name: "钱",
            py: "qián",
            bihua: "10画（简体），16画（繁体）",
            wx: "金",
            source: "钱姓主要源自彭祖篯铿。据《通志·氏族略》记载：“颛顼生老童，老童生吴回，吴回生陆终，陆终生彭祖，彭祖姓篯名铿，周封于钱，以地为氏。”",
            py2: "qian"
        },
        {
            name: "孙",
            py: "sūn",
            bihua: "6画",
            wx: "金",
            source: "孙姓主要源自姬姓、妫姓和姚姓等。周文王姬昌的后代惠孙，受封于“孙”（今河南范县西南），建立孙国，其后以国为氏。",
            py2: "sun"
        },
        {
            name: "李",
            py: "lǐ",
            bihua: "7画",
            wx: "木",
            source: "李姓出自嬴姓，血缘先祖为东夷族首领皋陶，得姓始祖为李利，李耳为十一世。",
            py2: "li"
        },
        {
            name: "周",
            py: "zhōu",
            bihua: "8画",
            wx: "金",
            source: "周姓主要源自姬姓，始祖为周文王姬昌。",
            py2: "zhou"
        },
        {
            name: "吴",
            py: "wú",
            bihua: "7画",
            wx: "木",
            source: "吴姓主要源自姬姓，是黄帝轩辕氏的直系后裔。吴国公子季札（公子札）因让国而逃到延陵，他的后人就以吴为氏。",
            py2: "wu"
        },
        {
            name: "郑",
            py: "zhèng",
            bihua: "8画",
            wx: "火",
            source: "郑姓主要源自子姓、姜姓、姬姓及少数民族改姓等。西周时，周宣王封其弟姬友于郑（今陕西华县东），建立郑国，姬友被称为郑桓公。",
            py2: "zheng"
        },
        {
            name: "王",
            py: "wáng",
            bihua: "4画",
            wx: "土",
            source: "王姓有多个来源，其中一支来自姬姓，为周文王之后，另有一支系由子姓改写而来。",
            py2: "wang"
        },
        {
            name: "冯",
            py: "féng",
            bihua: "5画（简体），12画（繁体）",
            wx: "水",
            source: "冯姓主要出自归姓，为冯简子之后。",
            py2: "feng"
        },
        {
            name: "陈",
            py: "chén",
            bihua: "7画",
            wx: "火",
            source: "陈姓主要源自妫姓，是舜帝的后裔。",
            py2: "chen"
        },
        {
            name: "褚",
            py: "chǔ",
            bihua: "13画",
            wx: "火",
            source: "褚姓源于官位，出自春秋时期各诸侯国官吏褚师，属于以官职称谓为氏。在《左传·襄公二十一年》中就有记载。",
            py2: "chu"
        },
        {
            name: "卫",
            py: "wèi",
            bihua: "3画",
            wx: "土",
            source: "卫字是一个常用的汉字，其含义与保护、守卫相关。作为姓氏，卫姓的来源多样，可能与古代的卫国或守卫职务有关。",
            py2: "wei"
        },
        {
            name: "蒋",
            py: "jiǎng",
            bihua: "12画",
            wx: "木",
            source: "蒋姓的本义同“菰”，即茭笋，是一种多年生宿根草本植物。作为姓氏，蒋姓的来源较早，可见于小篆文字。",
            py2: "jiang"
        },
        {
            name: "沈",
            py: "shěn",
            bihua: "7画（简体），18画（繁体）",
            wx: "水",
            source: "沈姓的来源与古代的沈国或沈水有关。沈也是一个常见的汉字，具有多种含义，如汁液、姓氏等。",
            py2: "shen"
        },
        {
            name: "韩",
            py: "hán",
            bihua: "12画",
            wx: "水",
            source: "韩姓与古代的韩国有关，最早可以追溯到中国周代的诸侯国名，位于今河南省中部、山西省东南部。",
            py2: "han"
        },
        {
            name: "杨",
            py: "yáng",
            bihua: "7画",
            wx: "木",
            source: "杨姓与杨树有关，杨树是一种常见的树木，因此杨姓可能来源于古代的杨树或杨树生长的地方。",
            py2: "yang"
        },
        {
            name: "朱",
            py: "zhū",
            bihua: "6画",
            wx: "木",
            source: "朱姓的来源有多种说法，其中之一是源于古代的朱国或朱邑。朱字本身也有红色的含义，因此也可能与红色有关。",
            py2: "zhu"
        },
        {
            name: "秦",
            py: "qín",
            bihua: "10画",
            wx: "木",
            source: "秦姓最早源于姬姓，周武王封其弟周公于鲁，周公之子伯禽裔孙食采于秦邑，子孙以邑名为氏。又周孝王封伯益后裔非子于秦亭，建立秦国，国亡，支庶以秦为氏。先秦时期，秦姓主要活动于河南、陕西、山东、四川、湖北、河北地区。",
            py2: "qin"
        },
        {
            name: "尤",
            py: "yóu",
            bihua: "4画（简体），6画（繁体）",
            wx: "土",
            source: "尤姓的得姓始祖是冉季载。尤姓源出有多种说法，其中一种认为宋代李纲在《梁奚谷漫录》中指出：“系出沈姓，五代王审知据闽，闽人沈姓者，避沈音，去水改尤氏。”",
            py2: "you"
        },
        {
            name: "许",
            py: "xǔ",
            bihua: "6画",
            wx: "木",
            source: "许姓的来源可能与古代的许国或许地有关。此外，许姓也可能来源于古代的官职或职业。",
            py2: "xu"
        },
        {
            name: "何",
            py: "hé，hē，hè",
            bihua: "7画",
            wx: "木",
            source: "何姓来源多元，其中之一起源于古代的官职“荷”，意为负荷。在古代，荷官的后代可能以官名为姓，逐渐演变为何姓。此外，何姓也可能与其他姓氏的改姓有关。",
            py2: "he"
        },
        {
            name: "吕",
            py: "lǚ",
            bihua: "6画（简体），7画（繁体）",
            wx: "火",
            source: "吕姓主要源自姜姓，是炎帝神农氏的后裔。吕姓的得姓始祖是伯夷，为姜姓吕氏的第一代始祖。",
            py2: "lu"
        },
        {
            name: "施",
            py: "shī",
            bihua: "9画",
            wx: "金",
            source: "施姓主要源于姬姓，为春秋时期鲁惠公之子姬尾生之后，属于以先祖名字为氏。",
            py2: "shi"
        },
        {
            name: "张",
            py: "zhāng、zhàng",
            bihua: "7画",
            wx: "火",
            source: "张姓的起源可以追溯至远古时代，据说黄帝的孙子挥创制出弓箭，因此被赐姓张。此外，张姓也可能由其他姓氏改姓而来。",
            py2: "zhang"
        },
        {
            name: "孔",
            py: "kǒng",
            bihua: "4画（部首）+ 3画（部首外）",
            wx: "木",
            source: "孔姓主要来源于子姓，是宋国君主的后代，以先祖的字或谥号为姓。",
            py2: "kong"
        },
        {
            name: "曹",
            py: "cáo",
            bihua: "11画",
            wx: "金",
            source: "曹姓来源众多，其中一支出自邾国（曹国）的曹叔振镛，以国名为氏。此外，曹姓也可能由其他姓氏改姓而来。",
            py2: "cao"
        },
        {
            name: "严",
            py: "yán",
            bihua: "7画（简体），8画（繁体）",
            wx: "木",
            source: "严姓源于庄姓，是中国南方典型的姓氏之一。史载，东汉时，因避讳明帝刘庄，改姓为严。奉严忌为始祖。",
            py2: "yan"
        },
        {
            name: "华",
            py: "huá，huà，huā",
            bihua: "6画（简体），10画（繁体）",
            wx: "水",
            source: "华姓有多个起源，其中一个主要来源是子姓，出自春秋时期宋国宋戴公之孙正考父，属于以先祖名字为氏。此外，华姓也可能与其他姓氏的改姓或赐姓有关。",
            py2: "hua"
        },
        {
            name: "金",
            py: "jīn",
            bihua: "8画",
            wx: "金",
            source: "金姓的姓源较多，最早的一支源于上古时的少昊帝，另一支较早的金氏出自西汉时的金日磾（“日磾”读作“密滴”）。",
            py2: "jin"
        },
        {
            name: "魏",
            py: "wèi",
            bihua: "17画",
            wx: "木",
            source: "魏是一个常见的姓氏，其起源可以追溯到古代的国名或地名。",
            py2: "wei"
        },
        {
            name: "陶",
            py: "táo",
            bihua: "10画（简体），16画（繁体）",
            wx: "火",
            source: "陶姓的起源与制陶业有关，古代从事制陶的工匠的后代可能以陶为姓。",
            py2: "tao"
        },
        {
            name: "姜",
            py: "jiāng",
            bihua: "9画",
            wx: "木",
            source: "姜姓是炎帝的后代，因炎帝的出生地而得姓为姜。",
            py2: "jiang"
        },
        {
            name: "戚",
            py: "qī",
            bihua: "11画",
            wx: "火",
            source: "戚字始见于商代甲骨文及商代金文，其古字形像边缘带齿的斧钺，本义是斧钺，古兵器名。后借用来表示悲伤、忧愁，也用作姓氏。",
            py2: "qi"
        },
        {
            name: "谢",
            py: "xiè",
            bihua: "17画",
            wx: "金",
            source: "谢姓的历史文化悠久，谢字的含义与辞别、感谢等相关。作为姓氏，谢姓的来源也有多种说法。",
            py2: "xie"
        },
        {
            name: "邹",
            py: "zōu",
            bihua: "7画（简体），12画（繁体）",
            wx: "金",
            source: "邹姓是一个古老的姓氏，其起源可能与古代的国名或地名有关。",
            py2: "zou"
        },
        {
            name: "喻",
            py: "yù",
            bihua: "12画",
            wx: "金",
            source: "喻姓的起源可能与古代的官职或地名有关，具体的出处和历史背景需要进一步的研究和资料查阅。",
            py2: "yu"
        },
        {
            name: "柏",
            py: "bǎi，bó",
            bihua: "9画",
            wx: "木",
            source: "柏姓的起源与柏树有关，可能是古代居住在柏树茂盛之地的人以柏为姓。",
            py2: "bai"
        },
        {
            name: "水",
            py: "shuǐ",
            bihua: "4画",
            wx: "水",
            source: "水姓的起源可能与古代的河流、水源或职业（如水工）有关，具体的出处和历史背景需要进一步的研究和资料查阅。",
            py2: "shui"
        },
        {
            name: "窦",
            py: "dòu",
            bihua: "13画，繁体13画",
            wx: "火",
            source: "窦姓主要源自姒姓，是夏朝少康帝的后代。此外，窦姓也有其他多个来源，如古代氐族窦氏、出自鲜卑族等。",
            py2: "dou"
        },
        {
            name: "章",
            py: "zhāng",
            bihua: "11画，繁体11画",
            wx: "火",
            source: "章姓主要来源于姜姓，为炎帝神农氏的后裔，以国名为氏。",
            py2: "zhang"
        },
        {
            name: "云",
            py: "yún",
            bihua: "4画，繁体12画",
            wx: "水",
            source: "云姓的起源之一是出自于缙云氏，是黄帝时夏官之后，以官名为姓氏。",
            py2: "yun"
        },
        {
            name: "苏",
            py: "sū",
            bihua: "7画，繁体19画",
            wx: "木",
            source: "苏姓的起源与上古帝王颛顼高阳氏有关，其裔孙吴回担任五岳之祝融，吴回之子陆终有六子，其中长子樊昆为苏姓始祖。",
            py2: "su"
        },
        {
            name: "潘",
            py: "pān",
            bihua: "15画，繁体16画",
            wx: "水",
            source: "潘字的含义与水有关，指河水漫流无方向的状态，类似沼泽滩。作为姓氏，潘姓的起源可能与这种地理特征或相关职业有关。",
            py2: "pan"
        },
        {
            name: "葛",
            py: "gě",
            bihua: "12画，繁体12画",
            wx: "木",
            source: "葛姓的起源与葛天氏有关，葛天氏是上古传说中的人物，被认为是葛姓的始祖。",
            py2: "ge"
        },
        {
            name: "奚",
            py: "xī",
            bihua: "7画，繁体10画",
            wx: "木",
            source: "奚姓的起源与古代官职有关，也可能与一些少数民族的姓氏转化而来。",
            py2: "xi"
        },
        {
            name: "范",
            py: "fàn",
            bihua: "8画，繁体15画",
            wx: "水",
            source: "范姓的起源与范蠡有关，范蠡是春秋末期越国相国，助越王勾践复仇灭吴后隐退，晚年定居于陶（今山东定陶西北），经商致富，后世尊其为商圣，号称“陶朱公”。",
            py2: "fan"
        },
        {
            name: "彭",
            py: "péng",
            bihua: "12画，繁体12画",
            wx: "水",
            source: "彭姓的起源可以追溯到上古时期，与彭祖有关。彭祖名篯铿，是颛顼帝玄孙陆终第三子，相传其寿命八百余岁，是个长寿之神，其后代以彭为姓。",
            py2: "peng"
        },
        {
            name: "郎",
            py: "láng",
            bihua: "8画，繁体11画",
            wx: "火",
            source: "郎姓的起源与古代官职“郎中”有关，也可能与地名或少数民族姓氏转化而来。",
            py2: "lang"
        },
        {
            name: "鲁",
            py: "lǔ",
            bihua: "12画，繁体12画",
            wx: "属水",
            source: "鲁姓起源于春秋时期的鲁国，是周公旦的儿子伯禽的封地，属于以国名为姓氏。现代鲁姓子孙，多为伯禽之后。",
            py2: "lu"
        },
        {
            name: "韦",
            py: "wéi",
            bihua: "4画，繁体9画",
            wx: "属土",
            source: "韦姓的起源有多个说法，其中一个主要来源是上古时代豕韦氏的后代，他们以国名为姓氏。",
            py2: "wei"
        },
        {
            name: "昌",
            py: "chāng",
            bihua: "8画，繁体8画",
            wx: "属金",
            source: "昌姓的起源与昌意有关，昌意是黄帝的儿子，其后代以昌为姓。",
            py2: "chang"
        },
        {
            name: "马",
            py: "mǎ",
            bihua: "3画，繁体10画",
            wx: "属水",
            source: "马姓的起源与马这种动物有关，可能源于古代的马夫或养马人。",
            py2: "ma"
        },
        {
            name: "苗",
            py: "miáo",
            bihua: "8画，繁体8画",
            wx: "属木",
            source: "苗姓的起源与初生的植物或没有秀穗的庄稼有关，寓意生命力和成长。",
            py2: "miao"
        },
        {
            name: "凤",
            py: "fèng",
            bihua: "4画，繁体14画",
            wx: "属水",
            source: "凤姓的起源与上古官职或姓氏有关，也可能与凤凰这种神鸟有关。",
            py2: "feng"
        },
        {
            name: "花",
            py: "huā",
            bihua: "7画，繁体7画",
            wx: "属木",
            source: "花姓的起源与华姓有关，古代花与华通用，后来专用花为花草之花，因此华姓也有改为花姓的。",
            py2: "hua"
        },
        {
            name: "方",
            py: "fāng",
            bihua: "4画，繁体4画",
            wx: "属水",
            source: "方姓的起源有多种说法，其中一种认为方姓源自上古时期的方雷氏，其后代以方为姓。",
            py2: "fang"
        },
        {
            name: "俞",
            py: "yú",
            bihua: "9画，繁体9画",
            wx: "属金",
            source: "俞姓的起源与古代官职有关，也可能与一些少数民族的姓氏转化而来。",
            py2: "yu"
        },
        {
            name: "任",
            py: "rén、rèn",
            bihua: "6画，繁体6画",
            wx: "属金",
            source: "任姓的起源与黄帝有关，黄帝赐封的儿子禺阳为任地，其后代以任为姓。",
            py2: "ren"
        },
        {
            name: "袁",
            py: "yuán",
            bihua: "10画，繁体10画",
            wx: "属土",
            source: "袁姓的起源与上古时期的袁部落有关，其后代以袁为姓。",
            py2: "yuan"
        },
        {
            name: "柳",
            py: "liǔ",
            bihua: "9画，繁体9画",
            wx: "属木",
            source: "柳姓的起源与古代的一种树木——柳树有关，可能是以树木为姓。",
            py2: "liu"
        },
        {
            name: "酆",
            py: "fēng",
            bihua: "9画",
            wx: "水",
            source: "酆姓是一个比较少见的姓氏，其起源和详细的历史背景可能较为复杂，具体出处需要进一步研究相关资料和文献。",
            py2: "feng"
        },
        {
            name: "鲍",
            py: "bào",
            bihua: "10画",
            wx: "水",
            source: "鲍姓起源有多种说法，一说出自姒姓，为春秋时夏禹裔孙敬叔之后，以国（鲍国）名为氏；一说出自姬姓，为春秋时期郑国大夫鲍叔牙之后，以父名为氏。",
            py2: "bao"
        },
        {
            name: "史",
            py: "shǐ",
            bihua: "5画",
            wx: "金",
            source: "史姓源出主要有两支：第一支源出仓颉之后，仓颉也称史皇氏，其后有史氏；第二支出自周太史佚的后代，以官为氏。",
            py2: "shi"
        },
        {
            name: "唐",
            py: "táng",
            bihua: "10画",
            wx: "火",
            source: "唐姓的起源可以追溯到上古时期，与尧帝有关。唐尧是上古五帝之一，其后代以国名为姓，形成唐氏。",
            py2: "tang"
        },
        {
            name: "费",
            py: "fèi",
            bihua: "9画",
            wx: "土",
            source: "费姓的起源有多个说法，其中一个主要来源是上古时期的费国，其后代以国名为姓。",
            py2: "fei"
        },
        {
            name: "廉",
            py: "lián",
            bihua: "13画",
            wx: "木",
            source: "廉姓是一个非常古老的姓氏，其来源至少可以追溯到4000年以前。根据《姓纂》一书的考证，廉姓是最正统的黄帝后裔。",
            py2: "lian"
        },
        {
            name: "岑",
            py: "cén",
            bihua: "7画",
            wx: "木",
            source: "岑姓的起源与山有关，其本义为小而高的山。岑姓可能源于古代居住在山地的部落或家族。",
            py2: "cen"
        },
        {
            name: "薛",
            py: "xuē",
            bihua: "16画",
            wx: "木",
            source: "薛姓的起源有多个说法，其中一个主要来源是上古时期的任姓部落，其后代以封地薛为姓。",
            py2: "xue"
        },
        {
            name: "雷",
            py: "léi",
            bihua: "13画",
            wx: "水",
            source: "雷姓的起源与古代官职或自然现象有关，可能是以官职名或自然现象为姓。",
            py2: "lei"
        },
        {
            name: "贺",
            py: "hè",
            bihua: "9画",
            wx: "水",
            source: "贺姓的起源有多个说法，其中一个主要来源是春秋时期的庆氏，其后代避难改姓为贺。",
            py2: "he"
        },
        {
            name: "倪",
            py: "ní",
            bihua: "10画",
            wx: "金",
            source: "倪姓的起源与上古时期的郳国有关，其后代以国名为姓。此外，也有说法认为倪姓源于春秋时期的儿姓。",
            py2: "ni"
        },
        {
            name: "汤",
            py: "tāng、shāng、tàng",
            bihua: "6画",
            wx: "水",
            source: "汤姓是一个多源的姓氏，起源有多种说法。其中，汤作为名词时，本指热水，后来用作姓氏。当汤作为动词，表示用热水烫熟食物或用热水暖物时，读作Tàng，后来为了与名词区别，增加了形符“火”，成为“烫”。此外，汤姓还可能源于子姓或姬姓等。",
            py2: "tang"
        },
        {
            name: "滕",
            py: "téng",
            bihua: "15画",
            wx: "火",
            source: "滕姓的起源有多个，其中一个是源自黄帝的第二十五子之滕氏，另一个是源自姬姓。滕姓的现代城市代表是山东滕州，且滕姓的始祖是错叔绣，其封号为滕王。",
            py2: "teng"
        },
        {
            name: "殷",
            py: "yīn、yān（古音）",
            bihua: "6画",
            wx: "土",
            source: "殷姓主要源于子姓，是帝喾嫡子殷契（后称阏伯）的后代。殷氏早期读音作yī，春秋末期亦改作yan，唐朝后亦皆混淆改姓氏读音作yin。另外，唐朝时，有“磤”字被简笔为“殷”，此后殷氏族人大多随之改用“磤”字读音，其姓氏读音亦随改作yīn。",
            py2: "yin"
        },
        {
            name: "罗",
            py: "luó",
            bihua: "8画",
            wx: "火",
            source: "罗姓主要源自妘姓，是颛顼帝之孙祝融氏的后裔，属于以国名为氏。罗姓的郡望为豫章郡，堂号为豫章堂。",
            py2: "luo"
        },
        {
            name: "毕",
            py: "bì",
            bihua: "6画",
            wx: "水",
            source: "毕姓是一个常见的姓氏，其起源可能与古代的一种工具或仪式有关，但具体出处和历史背景需要进一步研究。",
            py2: "bi"
        },
        {
            name: "郝",
            py: "hǎo",
            bihua: "9画",
            wx: "金",
            source: "郝姓的起源与古地名有关，在今中国陕西省户县和周至县。郝姓也可能源自其他姓氏或民族。",
            py2: "hao"
        },
        {
            name: "邬",
            py: "wū",
            bihua: "7画",
            wx: "土",
            source: "邬姓是一个典型的汉族姓氏，其来源有多个说法，包括源自妘姓或祁姓等。邬姓的代表人物有邬佐卿、邬干于等。",
            py2: "wu"
        },
        {
            name: "安",
            py: "ān",
            bihua: "6画",
            wx: "土",
            source: "安姓的起源有多种说法，其中包括源自黄帝之孙安昌意，以及源自春秋时期诸侯国中的安国等。安姓在中国历史上有着广泛的分布和重要的影响。",
            py2: "an"
        },
        {
            name: "常",
            py: "cháng",
            bihua: "8画",
            wx: "金",
            source: "常姓的起源可以追溯到上古时期，与“常”这个字所代表的“恒久、不变”的含义有关。常姓也可能源于古代的官职或地名。",
            py2: "chang"
        },
        {
            name: "乐",
            py: "yuè",
            bihua: "5画",
            wx: "火",
            source: "乐姓的起源与古代的音乐、乐器或乐官有关。乐姓在中国历史上有着悠久的传承和丰富的文化内涵。",
            py2: "yue"
        },
        {
            name: "于",
            py: "yú",
            bihua: "3画",
            wx: "土",
            source: "于姓的起源有多种说法，其中之一是源自姬姓，出自周武王之子邘叔的封地邘国。此外，于姓也可能与古代少数民族的姓氏转化有关。",
            py2: "yu"
        },
        {
            name: "时",
            py: "shí、chi或ci",
            bihua: "7画",
            wx: "金",
            source: "据先秦典籍《世本》所载，时姓来源于子姓，是商汤支庶的后代。",
            py2: "shi"
        },
        {
            name: "傅",
            py: "fù",
            bihua: "12画",
            wx: "水",
            source: "傅姓是一个常见的姓氏，其来源和历史背景较为复杂，可能涉及多个古代的部落、官职或地名。",
            py2: "fu"
        },
        {
            name: "皮",
            py: "pí",
            bihua: "5画",
            wx: "水",
            source: "皮姓在百家姓中排名第85位，其郡望为天水郡。关于皮姓的起源，有多种说法，其中一些代表人物包括皮日休和皮定钧。",
            py2: "pi"
        },
        {
            name: "卞",
            py: "biàn",
            bihua: "4画",
            wx: "木",
            source: "卞姓是一个多义词，既可以作为姓氏，也可以引申为急躁的意思。作为姓氏的起源，可能需要进一步查阅相关资料。",
            py2: "bian"
        },
        {
            name: "齐",
            py: "qí",
            bihua: "6画",
            wx: "金",
            source: "齐姓是一个古老的姓氏，其来源可能与古代的国名、地名或官职有关。在中国历史上，齐姓有着显著的地位和贡献。",
            py2: "qi"
        },
        {
            name: "康",
            py: "kāng",
            bihua: "11画",
            wx: "木",
            source: "康姓的起源可能与古代的康国、康叔或地名有关。康姓在中国历史上有着广泛的分布和重要的影响。",
            py2: "kang"
        },
        {
            name: "伍",
            py: "wǔ",
            bihua: "6画",
            wx: "土",
            source: "伍姓的起源可能与古代的官职、地名或部落有关。伍姓在中国历史上有着悠久的传承和丰富的文化内涵。",
            py2: "wu"
        },
        {
            name: "余",
            py: "yú",
            bihua: "7画",
            wx: "土",
            source: "余姓的起源有多种说法，其中一种认为它源自春秋时秦国由余之后，以祖名为氏。另一种说法是，余姓由余氏所改。",
            py2: "yu"
        },
        {
            name: "元",
            py: "yuán",
            bihua: "4画",
            wx: "木",
            source: "元姓的起源可以追溯到上古的尧帝，因为尧帝其中一个儿子叫元考，元考的后代就以元为姓。此外，也有说法认为元姓来自鲜卑族拓跋部的姓氏，北魏孝文帝改革时，将皇族拓跋氏改为元氏。",
            py2: "yuan"
        },
        {
            name: "卜",
            py: "bǔ、bo",
            bihua: "2画",
            wx: "水",
            source: "卜姓的起源与古代从事占卜职业的人有关，因为古代称占卜者为卜人，其后代就以卜为姓。卜姓的历史悠久，名人辈出。",
            py2: "bu"
        },
        {
            name: "顾",
            py: "gù",
            bihua: "10画",
            wx: "木",
            source: "顾姓有多个起源，其中一个主要来源于上古时代的顾国，其后代便以国名为姓。此外，也有说法是出自大储头顾分支妙林顾家童，属于因故改姓为氏。",
            py2: "gu"
        },
        {
            name: "孟",
            py: "mèng",
            bihua: "8画",
            wx: "水",
            source: "孟姓是一个常见的姓氏，其来源可能与古代的地名、官职或人物有关。在汉字中，“孟”字有“开始、首位”的含义，因此也可能与排行、辈分有关。",
            py2: "meng"
        },
        {
            name: "平",
            py: "píng",
            bihua: "5画",
            wx: "水",
            source: "平姓的起源主要有两个，一是源于姜姓，出自春秋时期齐国宰相晏婴的后代，属于以先祖名字为氏；二是源于姬姓，出自战国时期韩国君韩哀侯之子诺的封地平邑，属于以封邑名称为氏。",
            py2: "ping"
        },
        {
            name: "黄",
            py: "huáng",
            bihua: "11画",
            wx: "土",
            source: "黄姓是一个典型的多民族、多源流姓氏，主要源自嬴姓及少数民族改姓等。黄姓在远古时期就已经存在，可以追溯到上古时代的少昊和轩辕黄帝。按照《史记·秦本纪》记载，黄氏为嬴姓十四氏之一，是远古伯益的后裔。",
            py2: "huang"
        },
        {
            name: "和",
            py: "hé",
            bihua: "8画",
            wx: "水",
            source: "和姓主要源于以官职称谓为氏，古代的“和”是一种官职，负责协调和处理事务。因此，担任此官职的人的后代便以官名为姓，形成和氏。",
            py2: "he"
        },
        {
            name: "穆",
            py: "mù",
            bihua: "16画",
            wx: "金",
            source: "穆姓的来源有多个，其中一些可以追溯到上古的部落或地名，也可能与古代的官职或人物有关。穆姓在中国历史上有着显著的地位和贡献。",
            py2: "mu"
        },
        {
            name: "萧",
            py: "xiāo",
            bihua: "11画",
            wx: "木",
            source: "萧姓的起源与古代的地名或国名有关，萧国是春秋时宋国的大夫大心所建，萧国灭亡之后，其后代子孙遂以国名为姓，称为萧氏。",
            py2: "xiao"
        },
        {
            name: "尹",
            py: "yǐn",
            bihua: "4画",
            wx: "土",
            source: "尹姓的起源可以追溯到上古官职“尹”，为官的称尹，其后代以官名为姓。此外，尹姓也可能来源于少数民族的汉化改姓。",
            py2: "yin"
        },
        {
            name: "姚",
            py: "yáo",
            bihua: "9画",
            wx: "土",
            source: "姚姓的起源可以追溯到上古时期的舜帝姚重华的后裔，其后代子孙便以地为氏，称为姚氏。",
            py2: "yao"
        },
        {
            name: "邵",
            py: "shào",
            bihua: "7画",
            wx: "金",
            source: "邵姓的起源有多种说法，其中一种认为它出自姬姓，为周文王之后。此外，邵姓也可能与古代的官职、地名或少数民族有关。",
            py2: "shao"
        },
        {
            name: "湛",
            py: "zhàn",
            bihua: "12画",
            wx: "水",
            source: "湛姓的起源可能与古代的河流、地名或官职有关。在古代，“湛”字有清澈、深邃的含义，因此湛姓也可能与这些特质有关。",
            py2: "zhan"
        },
        {
            name: "汪",
            py: "wāng",
            bihua: "7画",
            wx: "水",
            source: "汪姓可能源自古代的汪芒国，后人以国名为姓。",
            py2: "wang"
        },
        {
            name: "祁",
            py: "qí（古音也有zhǐ音）",
            bihua: "6画",
            wx: "木",
            source: "祁姓可能源于上古时期，部分祁姓由姬姓所改，或源于祁邑。也有说法认为祁姓源于狄族，后汉化改为祁姓。",
            py2: "qi"
        },
        {
            name: "毛",
            py: "máo",
            bihua: "4画",
            wx: "木",
            source: "毛姓的起源有多种说法，其中之一是出自周武王母大姬的后代毛伯郑，属于以国名为氏。",
            py2: "mao"
        },
        {
            name: "禹",
            py: "yǔ",
            bihua: "9画",
            wx: "土",
            source: "禹姓源于姒姓，出自夏朝开国之君夏后大禹，属于以先祖名为氏。",
            py2: "yu"
        },
        {
            name: "狄",
            py: "dí或zhái",
            bihua: "7画（狄），8画（翟）",
            wx: "火",
            source: "狄姓有多个起源，可能源于商王朝始祖契之母狄，也可能源于黄帝后裔狄氏、翟氏，还有说法是源于契丹族。",
            py2: "di"
        },
        {
            name: "米",
            py: "mǐ",
            bihua: "6画",
            wx: "水",
            source: "米姓是一个多民族、多源流的姓氏，具体出处需进一步查阅资料。",
            py2: "mi"
        },
        {
            name: "贝",
            py: "bèi",
            bihua: "4画",
            wx: "水",
            source: "贝姓可能源于古代的货币“贝”，或以地为姓，也有说法认为贝姓出自姬姓，是鲁国公子食采于贝邑的后代。",
            py2: "bei"
        },
        {
            name: "明",
            py: "míng",
            bihua: "8画",
            wx: "水",
            source: "明姓的起源有多种说法，其中一种认为它源于谯明氏，也有说法认为明姓出自姬姓，是春秋时期虞国公族的后代。",
            py2: "ming"
        },
        {
            name: "臧",
            py: "zāng",
            bihua: "14画",
            wx: "金",
            source: "臧姓的起源与鲁孝公之子彄有关，他食采于臧邑，其后代以邑名为姓，形成臧姓。",
            py2: "zang"
        },
        {
            name: "计",
            py: "jì",
            bihua: "5画",
            wx: "水",
            source: "计姓的起源可能与古代的官职“计正”有关，其后代以官职为姓。",
            py2: "ji"
        },
        {
            name: "伏",
            py: "fú",
            bihua: "6画",
            wx: "水",
            source: "伏姓的起源有多种说法，其中一种认为它源于风姓，出自上古太昊伏羲氏的后代。",
            py2: "fu"
        },
        {
            name: "成",
            py: "chéng",
            bihua: "6画",
            wx: "金",
            source: "成姓的起源与古代的成国有关，其后代以国名为姓。",
            py2: "cheng"
        },
        {
            name: "戴",
            py: "dài",
            bihua: "17画（简体），18画（繁体）",
            wx: "火",
            source: "戴姓有多个起源，包括出自子姓，以国为氏；出自姬姓，以邑为氏等。",
            py2: "dai"
        },
        {
            name: "谈",
            py: "tán",
            bihua: "10画",
            wx: "火",
            source: "谈姓在中国是一个古老的姓氏，虽然不常见，但有着悠久的历史。其最早可追溯到上古周朝时期，源出于姬姓。在《百家姓》中，谈姓排名第117位。",
            py2: "tan"
        },
        {
            name: "宋",
            py: "sòng",
            bihua: "7画",
            wx: "金",
            source: "宋姓源自子姓，起源于春秋时期的宋国，属于以国名为姓。宋国灭亡后，其子孙以原国名“宋”为姓氏，成为宋姓的始祖。",
            py2: "song"
        },
        {
            name: "茅",
            py: "máo",
            bihua: "8画",
            wx: "木",
            source: "茅姓的起源与一种草名“茅”有关，本义为草名。后来，茅也用作地名，居住在此地的人便以茅为姓。",
            py2: "mao"
        },
        {
            name: "庞",
            py: "páng",
            bihua: "8画",
            wx: "火",
            source: "庞姓的起源可追溯到颛顼的后代庞降氏族部落，他们以庞为氏。另外，周文王之子毕公高的支庶受封于庞乡，其后代也以庞为姓。",
            py2: "pang"
        },
        {
            name: "熊",
            py: "xióng",
            bihua: "14画",
            wx: "水",
            source: "熊姓的起源有多种说法，其中一种认为它源于上古时期的熊图腾部落，属于以图腾为氏。",
            py2: "xiong"
        },
        {
            name: "纪",
            py: "jǐ",
            bihua: "6画",
            wx: "木",
            source: "纪姓作为一个姓氏，其读音为Jǐ。纪姓的起源与姜姓有关，郡望为天水、高阳、平阳、襄平等地。",
            py2: "ji"
        },
        {
            name: "舒",
            py: "shū",
            bihua: "12画",
            wx: "金",
            source: "舒姓的起源与周朝时皋陶的后代被封于舒国有关。公元前657年，舒子平被徐国所灭，后又复国，其国君族人以舒为姓。",
            py2: "shu"
        },
        {
            name: "屈",
            py: "qū",
            bihua: "8画",
            wx: "木",
            source: "屈姓的起源与春秋时期的楚国有关，楚武王熊通的儿子瑕，被封在屈地，称为屈瑕，他的后代以封地为氏，遂称屈氏。",
            py2: "qu"
        },
        {
            name: "项",
            py: "xiàng",
            bihua: "9画",
            wx: "水",
            source: "项姓的起源与西周时期的项国有关，项国是周朝分封的同姓诸侯国，其子孙以国名为姓。",
            py2: "xiang"
        },
        {
            name: "祝",
            py: "zhù",
            bihua: "9画",
            wx: "火",
            source: "祝姓的起源可以追溯到上古时期的火神祝融，其后代以祝为姓。此外，祝姓也可能来源于其他古代官职或地名。",
            py2: "zhu"
        },
        {
            name: "董",
            py: "dǒng",
            bihua: "12画",
            wx: "火",
            source: "董姓的起源有多种说法，其中一种认为它源于董父，他以豢龙而被舜赐姓为董，其后代便以董为姓。",
            py2: "dong"
        },
        {
            name: "梁",
            py: "liáng",
            bihua: "11画",
            wx: "火",
            source: "梁姓是一个典型的汉族姓氏，其来源可以追溯到上古时期的梁国或梁邑。在《百家姓》中，梁姓排名第128位。",
            py2: "liang"
        },
        {
            name: "杜",
            py: "dù",
            bihua: "7画",
            wx: "木",
            source: "杜姓的起源与上古时期的杜康有关，他是黄帝时期的一位大臣，擅长酿酒，其后代以杜为姓。另外，杜姓也可能与古代杜国或杜地有关。",
            py2: "du"
        },
        {
            name: "阮",
            py: "ruǎn",
            bihua: "12画",
            wx: "木",
            source: "阮姓的起源与古代的阮国或阮地有关，属于以国为姓或以地为姓。阮姓在中国历史上有着悠久的传承，其名人辈出。",
            py2: "ruan"
        },
        {
            name: "蓝",
            py: "lán",
            bihua: "13画",
            wx: "木",
            source: "蓝姓的起源与古代的蓝田或蓝地有关，也有说法认为蓝姓源于少数民族的汉化改姓。在《百家姓》中，蓝姓排名第131位。",
            py2: "lan"
        },
        {
            name: "闵",
            py: "mǐn",
            bihua: "7画",
            wx: "水",
            source: "闵姓的起源与古代的闵国或闵地有关，也有说法认为闵姓出自姬姓，为鲁庄公之子公子开的后代，属于以谥号为氏。",
            py2: "min"
        },
        {
            name: "席",
            py: "xí",
            bihua: "10画",
            wx: "金",
            source: "席姓的起源与古代的席国或席地有关，也有说法认为席姓源于少数民族的汉化改姓。在《百家姓》中，席姓排名第133位。",
            py2: "xi"
        },
        {
            name: "季",
            py: "jì",
            bihua: "8画",
            wx: "木",
            source: "季姓有多个起源，一说是来自春秋时期公族季札的后代，一说是来自上古季连的后代，还有说法认为季姓与排行兄弟有关。季札是季姓的得姓始祖。",
            py2: "ji"
        },
        {
            name: "路",
            py: "lù",
            bihua: "13画",
            wx: "火",
            source: "路姓的起源与古代的路国或路地有关，也有说法认为路姓出自姜姓，为炎帝的后代。",
            py2: "lu"
        },
        {
            name: "贾",
            py: "jiǎ",
            bihua: "10画",
            wx: "水",
            source: "贾姓的起源与古代的贾国或贾地有关，也有说法认为贾姓出自姬姓，为晋献公之子公子的后代。",
            py2: "jia"
        },
        {
            name: "娄",
            py: "lóu",
            bihua: "9画",
            wx: "火",
            source: "娄姓的起源与古代的娄国或娄地有关，也有说法认为娄姓出自姒姓，是大禹的后代。",
            py2: "lou"
        },
        {
            name: "危",
            py: "wēi",
            bihua: "6画",
            wx: "木",
            source: "危姓的起源与古代的危国或危地有关，也有说法认为危姓出自姬姓，为周武王庶子姬叔的后代。",
            py2: "wei"
        },
        {
            name: "江",
            py: "jiāng",
            bihua: "6画",
            wx: "水",
            source: "江姓的起源与古代的江国或江地有关，也有说法认为江姓出自嬴姓，为伯益的后代。",
            py2: "jiang"
        },
        {
            name: "童",
            py: "tóng",
            bihua: "12画",
            wx: "金",
            source: "童姓的起源并不十分明确，但可以确定的是，童姓在中国是一个历史悠久的姓氏，有着广泛的分布和众多的族人。",
            py2: "tong"
        },
        {
            name: "颜",
            py: "yán",
            bihua: "15画",
            wx: "木",
            source: "颜姓起源于西周时期，与古代的颜邑或颜国有关。另外，颜姓也可能源于姒姓，是大禹的后代。在汉字中，“颜”的本义是指两眉之间，俗称“印堂”的部位，后引申为额头、脸面等意义。",
            py2: "yan"
        },
        {
            name: "郭",
            py: "guō",
            bihua: "10画",
            wx: "木",
            source: "郭姓的起源有多个，其中包括夏代的郭支、商代的郭崇等。另外，郭姓也可能来源于古代居住在外城的人，因为“郭”在古代指的是外城。",
            py2: "guo"
        },
        {
            name: "梅",
            py: "méi",
            bihua: "11画",
            wx: "木",
            source: "梅姓可能与梅花这种植物有关，因为梅花在中国文化中有着独特的象征意义。梅姓的人可能以梅花为象征，寓意坚韧、高雅和不屈不挠的精神。",
            py2: "mei"
        },
        {
            name: "盛",
            py: "shèng（主要读音），也可读chéng",
            bihua: "11画",
            wx: "金",
            source: "盛姓的起源与古代的盛国或盛地有关，也可能与盛装的祭器或盛大的仪式有关。在汉字中，“盛”有多重含义，包括丰富、繁盛、强大等。",
            py2: "sheng"
        },
        {
            name: "林",
            py: "lín",
            bihua: "8画",
            wx: "木",
            source: "林姓的起源与树木、森林有关，可能源于居住在林木茂盛地区的人。在汉字中，“林”的本义是成片的树木或竹子，引申为聚集在一起的人事。",
            py2: "lin"
        },
        {
            name: "徐",
            py: "xú",
            bihua: "10画",
            wx: "金",
            source: "徐姓的起源有多个，其中一个说法是源于嬴姓，是颛顼帝玄孙伯益之子若木的后裔。另外，徐姓也可能与古代的徐国或徐地有关。",
            py2: "xu"
        },
        {
            name: "邱",
            py: "qiū",
            bihua: "7画（简体），8画（繁体）",
            wx: "木",
            source: "邱姓一般认为是由丘姓避讳而来，最早一支丘姓源出姜姓，姜子牙封于齐而都营丘，其支庶居于营丘者，遂以丘为氏，世居扶风。汉平帝时有扶风人丘俊，持节安抚江准，居吴兴，在南北朝时形成了吴兴丘姓望族，丘姓主体已经由中原和北方移入江南。",
            py2: "qiu"
        },
        {
            name: "骆",
            py: "luò",
            bihua: "9画",
            wx: "火",
            source: "骆姓的起源可追溯到上古时期，与商朝名相马骆有关。马骆的后代以他的名字为姓，形成了骆姓。此外，骆姓也可能与古代骆国或骆地有关。",
            py2: "luo"
        },
        {
            name: "高",
            py: "gāo",
            bihua: "10画",
            wx: "木",
            source: "高姓有多个起源，其中一个说法是源于姜姓，是炎帝的后裔。另外，高姓也可能与古代的封地、官职或地名有关。",
            py2: "gao"
        },
        {
            name: "夏",
            py: "xià",
            bihua: "10画",
            wx: "火",
            source: "夏姓的起源与夏朝有关，是夏朝王族的后代。另外，夏姓也可能与古代的夏国或夏地有关。",
            py2: "xia"
        },
        {
            name: "蔡",
            py: "cài",
            bihua: "14画",
            wx: "木",
            source: "蔡姓的起源与蔡国有关，是周朝分封的诸侯国之一。蔡国的子孙以国名为姓，形成了蔡姓。此外，蔡姓也可能与古代的蔡地或官职有关。",
            py2: "cai"
        },
        {
            name: "田",
            py: "tián",
            bihua: "5画",
            wx: "火",
            source: "田姓的起源有多种说法，其中之一是楚平王熊弃疾的支庶孙田公它成，其后裔子孙以其先祖名字为姓氏，称田公氏，后省文简化为单姓田氏。",
            py2: "tian"
        },
        {
            name: "樊",
            py: "fán",
            bihua: "15画",
            wx: "木",
            source: "樊姓的汉字结构较为特殊，其笔画数为15画，部首为“木”。樊姓的拼音和笔画相对固定，而关于其五行属性，通常基于姓名学或占卜学的观点，不同的资料或学派可能会有不同的解释。",
            py2: "fan"
        },
        {
            name: "胡",
            py: "hú",
            bihua: "9画",
            wx: "土",
            source: "胡姓是中华姓氏之一，起源于周朝诸侯国胡国。胡国是归附于周朝的西戎部落建立的方国。",
            py2: "hu"
        },
        {
            name: "凌",
            py: "líng",
            bihua: "10画",
            wx: "火",
            source: "凌姓出自姬姓，是黄帝十世嫡长孙舜帝姚重华的姚姓衍生姓氏的后裔。头一个以凌为姓的人，是出身于周代初年周文王幼子所建的卫国。",
            py2: "ling"
        },
        {
            name: "霍",
            py: "huò",
            bihua: "16画",
            wx: "水",
            source: "霍姓的汉字结构中，部首为“雨”，整体结构相对独特。关于霍姓的起源，可能与古代的国名、地名或官职有关，但具体出处尚需进一步的历史文献研究来确认。",
            py2: "huo"
        },
        {
            name: "虞",
            py: "yú",
            bihua: "13画",
            wx: "火",
            source: "虞姓的起源可追溯到上古时期，据说出自舜帝姚重华之子商均，以国名为氏。此外，虞姓也可能与古代的虞国或虞地有关。",
            py2: "yu"
        },
        {
            name: "万",
            py: "wàn",
            bihua: "3画",
            wx: "水",
            source: "万姓的得姓始祖为芮伯万，其后代以万为姓。万姓在汉字中的笔画数较少，仅为3画，结构简单明了。",
            py2: "wan"
        },
        {
            name: "支",
            py: "zhī",
            bihua: "4画",
            wx: "火",
            source: "支姓的起源并不十分明确，但据一些历史文献记载，支姓可能来源于古代的官职名、地名或与某些历史事件相关的人物。具体的出处需要进一步的研究来确定。",
            py2: "zhi"
        },
        {
            name: "柯",
            py: "kē",
            bihua: "9画",
            wx: "木",
            source: "柯姓的起源可追溯到春秋时期，是吴国公子柯卢的后代，以先祖名字为姓氏，形成柯姓。此外，柯姓也可能与古代的柯国或柯地有关。",
            py2: "ke"
        },
        {
            name: "昝",
            py: "zǎn",
            bihua: "9画",
            wx: "金",
            source: "昝姓的起源较为古老，但具体的历史文献记载并不多见。一种说法认为昝姓可能来源于古代的昝国或昝地，但具体的出处仍需进一步的研究来确定。",
            py2: "zan"
        },
        {
            name: "管",
            py: "guǎn",
            bihua: "14画",
            wx: "木",
            source: "管姓的起源有多个说法，其中之一是出自姬姓，为周文王之后，以国名为氏。此外，管姓也可能与古代的管国或管地有关。",
            py2: "guan"
        },
        {
            name: "卢",
            py: "lú",
            bihua: "5画",
            wx: "火",
            source: "卢姓的起源有多种说法，其中包括高傒之后以卢为姓，以及姜姓卢氏等。卢姓在中国历史上有着悠久的传承和广泛的分布。",
            py2: "lu"
        },
        {
            name: "莫",
            py: "mò、mù",
            bihua: "10画",
            wx: "水",
            source: "莫姓的起源并不十分明确，但作为一个常见的姓氏，它在中国有着悠久的历史和广泛的分布。在汉字中，“莫”有多重含义，包括不要、没有、不能等。",
            py2: "mo"
        },
        {
            name: "经",
            py: "jīng",
            bihua: "8画",
            wx: "木",
            source: "经姓的起源与古代的经国或经地有关，属于以国为姓或以地为姓的情况。另外，经姓也可能与古代的官职或职业有关，比如掌管经典文献的官员或从事经典传承的学者。",
            py2: "jing"
        },
        {
            name: "房",
            py: "fáng",
            bihua: "8画",
            wx: "水",
            source: "房姓的起源可以追溯到上古时期，与尧帝的儿子丹朱有关。丹朱被封于房邑，其后代便以房为姓。此外，房姓也可能与古代的房国或房地有关。",
            py2: "fang"
        },
        {
            name: "裘",
            py: "qiú",
            bihua: "13画",
            wx: "水",
            source: "裘姓的起源与古代的皮衣有关，属于以物为姓的情况。在古代，裘是一种用兽皮制成的衣服，保暖性能良好，因此裘姓可能与从事皮革制作或贸易的家族有关。",
            py2: "qiu"
        },
        {
            name: "缪",
            py: "miào",
            bihua: "14画",
            wx: "火",
            source: "缪姓的起源可以追溯到西周和春秋时期，与秦国的缪氏有关。缪姓在历史上的名人辈出，如缪荃孙等，为缪姓增添了光彩。",
            py2: "miao"
        },
        {
            name: "干",
            py: "gān",
            bihua: "3画",
            wx: "木",
            source: "干姓的起源有多种说法，其中一种认为干姓来源于古代的干国，位于江苏扬州一带。此外，干姓也可能与比干的后代有关，为避祸改姓为干。干姓在现代是较为罕见的姓氏。",
            py2: "gan"
        },
        {
            name: "解",
            py: "xiè",
            bihua: "13画",
            wx: "木",
            source: "解姓的起源与姬姓有关，出自周武王之孙姬良的封地，属于以封邑名称为氏的情况。解姓在历史上也有其独特的文化和传承。",
            py2: "xie"
        },
        {
            name: "应",
            py: "yīng、yìng",
            bihua: "7画",
            wx: "土",
            source: "应姓的起源较为古老，其中一个说法是起源于周武王之子应叔，其后代以应为姓。此外，应姓也可能与古代的应国或应地有关。",
            py2: "ying"
        },
        {
            name: "宗",
            py: "zōng",
            bihua: "8画",
            wx: "金",
            source: "宗姓的起源与古代的宗庙、宗族有关，属于以宗族名称为姓的情况。在古代社会，宗庙是祭祀祖先的地方，宗族则是具有共同血缘关系的家族群体，因此宗姓可能与这些概念有关。",
            py2: "zong"
        },
        {
            name: "丁",
            py: "dīng",
            bihua: "2画",
            wx: "火",
            source: "丁姓的起源有多种说法，其中一种认为丁姓来源于商朝时期的丁侯，其后代以丁为姓。此外，丁姓也可能与古代的丁国或丁地有关。丁姓在中国历史上有着悠久的传承和广泛的分布。",
            py2: "ding"
        },
        {
            name: "宣",
            py: "xuān",
            bihua: "9画",
            wx: "金",
            source: "宣姓的起源可以追溯到古代，与周宣王有关。周宣王是周朝的一位贤明君主，其后代以他的谥号为姓，形成了宣姓。此外，宣姓也可能与古代的宣国或宣地有关。",
            py2: "xuan"
        },
        {
            name: "贲",
            py: "bēn、féi、béi",
            bihua: "9画",
            wx: "水",
            source: "贲姓有十起源，包括来自鲁国县贲父的后代，来自戎族氏族，来自晋国苗贲父的后代，来自秦国嬴姓的后代，以及来自两周时期的特殊称谓等。",
            py2: "ben"
        },
        {
            name: "邓",
            py: "dèng",
            bihua: "4画，繁体14画",
            wx: "火",
            source: "邓姓源于姬姓，出自曼姓始祖邓侯牵挽政难留，六十年来亦倦游。至圣眼高无俗韵，大儒人唤有诗侯。",
            py2: "deng"
        },
        {
            name: "郁",
            py: "yù",
            bihua: "9画，繁体鬱13画",
            wx: "水",
            source: "郁姓可能源于古代的郁国或郁地，也可能与某些历史人物或事件有关。具体的起源背景需进一步的历史文献研究来确认。",
            py2: "yu"
        },
        {
            name: "单",
            py: "shàn",
            bihua: "8画",
            wx: "火",
            source: "单姓源出于姬姓，以邑名为氏。",
            py2: "shan"
        },
        {
            name: "杭",
            py: "háng",
            bihua: "8画",
            wx: "木",
            source: "杭姓源于姒姓，是大禹的后代，以国名为氏。另一种说法是杭姓出自抗姓，因避讳而改。",
            py2: "hang"
        },
        {
            name: "洪",
            py: "hóng",
            bihua: "9画",
            wx: "水",
            source: "洪姓的起源与古代的洪水有关，属于以自然现象为姓的情况。此外，洪姓也可能与古代的官职、地名或历史人物有关。",
            py2: "hong"
        },
        {
            name: "包",
            py: "bāo",
            bihua: "5画",
            wx: "水",
            source: "包姓源于风姓包氏，为三皇之首包羲字伏羲号黄熊谥太昊后裔。",
            py2: "bao"
        },
        {
            name: "诸",
            py: "zhū",
            bihua: "10画",
            wx: "金",
            source: "诸姓可能来源于古代的诸侯国或诸地，也可能与某些历史人物或事件有关。具体的起源需进一步的历史文献研究来确认。",
            py2: "zhu"
        },
        {
            name: "左",
            py: "zuǒ",
            bihua: "5画",
            wx: "火",
            source: "左姓的起源有多种说法，包括以官名为姓、以方位为姓等。具体的起源背景需进一步的历史文献研究来确认。",
            py2: "zuo"
        },
        {
            name: "石",
            py: "shí",
            bihua: "5画",
            wx: "金",
            source: "石姓的起源与古代的石头、石器或石制工艺品有关，也可能与地名或官职有关。具体的起源背景需进一步的历史文献研究来确认。",
            py2: "shi"
        },
        {
            name: "崔",
            py: "cuī",
            bihua: "11画",
            wx: "木",
            source: "崔姓源于姜姓，出自西周时期齐国君主丁公伋的嫡长子季子的封地，属于以封邑名称为氏。",
            py2: "cui"
        },
        {
            name: "吉",
            py: "jí",
            bihua: "6画，繁体6画",
            wx: "木",
            source: "吉姓的起源可能与古代的吉祥、吉利等概念有关，属于以美好寓意为姓的情况。具体的历史出处需要进一步研究。",
            py2: "ji"
        },
        {
            name: "钮",
            py: "niǔ",
            bihua: "9画",
            wx: "金",
            source: "钮姓的起源可能与古代的印钮或纽结有关，属于以物为姓的情况。具体的历史出处需要进一步研究。",
            py2: "niu"
        },
        {
            name: "龚",
            py: "gōng",
            bihua: "11画",
            wx: "木",
            source: "龚姓的起源有多种说法，其中一种认为龚姓源自共姓，是共工氏的后代。另一种说法是龚姓出自姬姓，为晋献公之后，以国名为氏。",
            py2: "gong"
        },
        {
            name: "程",
            py: "chéng",
            bihua: "12画",
            wx: "火",
            source: "程姓的起源与古代的国名、地名有关，也可能与官职、人物等有关。据《通志·氏族略》记载，程姓是重、黎的后裔。周宣王时，重黎的裔孙程伯休父入朝为大司马，后又因攻占徐方有功，被周王赐以程地，其后子孙以国为氏，称程氏。",
            py2: "cheng"
        },
        {
            name: "嵇",
            py: "jī",
            bihua: "10画",
            wx: "木",
            source: "嵇姓的起源可能与古代的嵇山有关，属于以地为姓的情况。此外，嵇姓也可能与古代的一些历史人物或事件有关。",
            py2: "ji"
        },
        {
            name: "邢",
            py: "xíng",
            bihua: "6画",
            wx: "金",
            source: "邢姓的起源与古代的邢国有关，属于以国名为姓的情况。",
            py2: "xing"
        },
        {
            name: "滑",
            py: "huá",
            bihua: "12画",
            wx: "水",
            source: "滑姓源流较纯正，一说出自姬姓，以国名为氏。此外，彝族滑氏，出自秦、汉时期古诺苏彝人的居地名称。",
            py2: "hua"
        },
        {
            name: "裴",
            py: "péi",
            bihua: "14画",
            wx: "木",
            source: "裴姓的起源有多种说法，其中一种认为裴姓源于周朝的裴邑，以邑名为姓。另一种说法是裴姓出自春秋时期晋国大夫裴叔的儿子，属于以先祖名字为姓。",
            py2: "pei"
        },
        {
            name: "陆",
            py: "lù",
            bihua: "7画",
            wx: "火",
            source: "陆姓的起源与古代的陆终、陆浑国等有关，属于以地名为姓的情况。此外，陆姓也可能与古代的一些官职、人物等有关。",
            py2: "lu"
        },
        {
            name: "荣",
            py: "róng",
            bihua: "9画",
            wx: "木",
            source: "荣姓的起源有多种说法，其中一种认为荣姓源自古代的荣国，属于以国名为姓的情况。另一种说法是荣姓出自上古帝王黄帝，属于以先祖名字为姓。",
            py2: "rong"
        },
        {
            name: "翁",
            py: "wēng",
            bihua: "10画",
            wx: "土",
            source: "翁姓的起源有多种说法，其中一种认为翁姓源自上古时期，最早可追溯到周武王姬发的后裔翁氏。另一种说法是翁姓出自姬姓，为周昭王之后，以邑名为氏。",
            py2: "weng"
        },
        {
            name: "荀",
            py: "xún",
            bihua: "9画",
            wx: "木",
            source: "荀姓是一个古老的姓氏，据说起源于传说中的一种香草，也作为姓氏使用。关于荀姓的具体历史出处，可能需要进一步查阅历史资料或姓氏研究文献。",
            py2: "xun"
        },
        {
            name: "羊",
            py: "yáng",
            bihua: "6画",
            wx: "土",
            source: "羊姓是一个具有悠久历史的姓氏，最早可以追溯到中华人文始祖之一的黄帝系统，是黄帝裔孙后稷的后代。羊姓在中国有着广泛的分布和深厚的文化底蕴。",
            py2: "yang"
        },
        {
            name: "於",
            py: "yū",
            bihua: "7画",
            wx: "土",
            source: "於姓的起源并不十分明确，但“於”原是“乌”的异体字，始见于西周金文。作为姓氏使用时读yū。此外，於也常用作介词，读yú，在古汉语中是常用的虚词。",
            py2: "yu"
        },
        {
            name: "惠",
            py: "huì",
            bihua: "12画",
            wx: "水",
            source: "惠姓的起源并不十分明确，但“惠”字在汉字中常含有恩惠、好处的含义。惠姓在中国人口中并不罕见，且分布广泛。",
            py2: "hui"
        },
        {
            name: "甄",
            py: "zhēn",
            bihua: "13画",
            wx: "金",
            source: "甄姓是一个具有悠久历史的姓氏，起源于五帝时代，属帝舜后裔。甄姓在宋版《百家姓》中列第205位，并且在现代中国也有一定的人口分布。",
            py2: "zhen"
        },
        {
            name: "麴",
            py: "qū",
            bihua: "18画（简体字合并后）",
            wx: "木",
            source: "麴姓是一个古老的姓氏，以汝南（今属河南）为郡望。在传统上，“麴”被视为正字，而“麯”为俗字。现代汉字简化后，“麴”被定为异体字，后恢复部分字义并定为次常用简化字，简作“麹”。",
            py2: "qu"
        },
        {
            name: "家",
            py: "jiā",
            bihua: "10画",
            wx: "木",
            source: "家姓的起源并不十分明确，但在中国是一个常见的姓氏。关于家姓的具体历史出处和含义，需要进一步的历史研究和文献资料来揭示。",
            py2: "jia"
        },
        {
            name: "邴",
            py: "bǐng",
            bihua: "7画",
            wx: "水",
            source: "邴是一个古老的姓氏，起源于古代中国。据《汉字源流字典》记载，邴是古地名，位于今山东省费县。因此，邴姓可能与该地的居民有关。",
            py2: "bing"
        },
        {
            name: "糜",
            py: "mí",
            bihua: "17画",
            wx: "水",
            source: "糜姓主要源自姒姓和芈姓。在历史上，糜姓人物如三国时期的蜀汉糜竺、糜芳等都有一定的影响力。",
            py2: "mi"
        },
        {
            name: "松",
            py: "sōng",
            bihua: "8画",
            wx: "木",
            source: "松姓有多个起源。其中一个起源与秦始皇和松树的故事有关。另一个起源则与清代满族改姓有关。此外，彝族、壮族、台湾布农人等民族也有松姓。",
            py2: "song"
        },
        {
            name: "井",
            py: "jǐng",
            bihua: "4画",
            wx: "火",
            source: "井姓起源于姜姓和姬姓。最早的姜姓井族可能建立在河北省邢台市一带。此外，井姓在《清朝通志·氏族略·附载蒙古八旗姓》中也有记载，与蒙古族、满族的部分氏族改汉姓为井有关。",
            py2: "jing"
        },
        {
            name: "段",
            py: "duàn",
            bihua: "9画",
            wx: "火",
            source: "段姓的起源与“段”字的本义有关，即“椎物”。古代文献《说文解字》和《殷周文字释丛》对“段”字有所解释，指出其象形意义。",
            py2: "duan"
        },
        {
            name: "富",
            py: "fù",
            bihua: "12画",
            wx: "水",
            source: "富姓的五行属性为水。关于富姓的具体起源，可能涉及多种历史背景和文化因素，需要进一步的文献研究来揭示。",
            py2: "fu"
        },
        {
            name: "巫",
            py: "wū",
            bihua: "7画",
            wx: "火",
            source: "巫姓的起源与古代的巫者有关。巫者在古代社会中扮演了重要的角色，包括降神、医术等。因此，巫姓可能与这些古老的职业和信仰有关。",
            py2: "wu"
        },
        {
            name: "乌",
            py: "wū",
            bihua: "4画",
            wx: "火",
            source: "乌姓是一个古老的姓氏，其具体起源并不十分明确。但“乌”字在汉字中常用来表示黑色或乌鸦，可能与乌姓的某些含义或起源有关。",
            py2: "wu"
        },
        {
            name: "谷",
            py: "gǔ",
            bihua: "7画",
            wx: "木",
            source: "谷姓是一个古老的姓氏，具体起源并不十分明确。但根据已有的历史文献和姓氏研究资料，谷姓可能与古代的谷地、谷物等自然元素或相关职业有关。",
            py2: "gu"
        },
        {
            name: "车",
            py: "chē",
            bihua: "7画",
            wx: "金",
            source: "车姓的起源可以追溯到古代，其始祖为车千秋。在百家姓中，车姓的排名会随着不同版本的百家姓而有所变动，但总体上都属于较为常见的姓氏之一。",
            py2: "che"
        },
        {
            name: "侯",
            py: "hóu",
            bihua: "9画",
            wx: "水",
            source: "侯姓主要来源于五支，包括姬姓、姒姓等。在宋版《百家姓》中，侯姓位列第230位，而在当代百家姓中则排名第77位。侯姓在中国人口中分布广泛，尤其在湖南、安徽、河北、辽宁等地较为集中。",
            py2: "hou"
        },
        {
            name: "宓",
            py: "mì 或 fú",
            bihua: "8画",
            wx: "水（当读音为mì时）",
            source: "宓是一个多音字，既可以读作mì，也可以读作fú。当读作mì时，表示安静的意思，也作为姓氏使用。宓姓的具体起源并不十分明确，可能需要进一步的历史研究和文献资料来揭示。",
            py2: "mi"
        },
        {
            name: "蓬",
            py: "péng",
            bihua: "10画",
            wx: "木",
            source: "蓬姓的起源与古代的地名蓬州有关。据《万姓统谱》记载，西周时期，周天子封支子于蓬州（今四川省蓬安县一带），建立了蓬国。后来蓬国被吞灭，其国民便以国名为姓氏，形成蓬姓。",
            py2: "peng"
        },
        {
            name: "全",
            py: "quán",
            bihua: "6画",
            wx: "火",
            source: "全姓主要出自西周时期官职泉府官。据《鲒琦亭集·全氏世谱》记载，全姓出自泉姓，西周时有泉府之官，后代便以泉为姓，后来因泉字的写法不同，而形成全姓。",
            py2: "quan"
        },
        {
            name: "郗",
            py: "chī 或 xī",
            bihua: "9画",
            wx: "水",
            source: "郗姓源流单一，源出己姓，是黄帝孙颛顼后裔，以邑名为氏。郗姓的最早发祥地在沁阳，是一个具有悠久历史的姓氏。",
            py2: "chi"
        },
        {
            name: "宫",
            py: "gōng",
            bihua: "9画",
            wx: "金",
            source: "宫姓的起源有多种说法，其中包括源自姬姓、以封地名为姓等。在《左传·僖公五年》、《春秋谷梁传·虞师晋师灭夏阳》等古籍中都有关于宫姓的记载。",
            py2: "gong"
        },
        {
            name: "宁",
            py: "níng",
            bihua: "5画",
            wx: "火",
            source: "宁姓的来源有多种，其中一个主要来源是卫康叔之后，以谥号为氏。另外，宁姓也可能来源于少数民族的汉化改姓。",
            py2: "ning"
        },
        {
            name: "仇",
            py: "qiú",
            bihua: "4画",
            wx: "金",
            source: "仇姓源出有三，其中之一是出自九姓，源出殷末三公之一的九吾氏。",
            py2: "qiu"
        },
        {
            name: "栾",
            py: "luán",
            bihua: "10画",
            wx: "火",
            source: "栾姓的起源主要有两个，一是出自姬姓，为晋靖侯的孙子栾宾的后代；二是出自姜姓。",
            py2: "luan"
        },
        {
            name: "暴",
            py: "bào",
            bihua: "15画",
            wx: "水",
            source: "暴姓主要源自姬姓，以国名为氏。其先祖为暴公氏，后省文简化为单姓暴氏。春秋初期，暴国被郑国吞并，其后代子孙便以原国名为姓氏。",
            py2: "bao"
        },
        {
            name: "甘",
            py: "gān",
            bihua: "5画",
            wx: "木",
            source: "甘姓的来源比较广泛，但在古代名人中有甘盘、甘茂、甘罗、甘宁等。甘姓在《郑通志·氏族略》中也有收录。",
            py2: "gan"
        },
        {
            name: "钭",
            py: "dǒu",
            bihua: "9画",
            wx: "金",
            source: "钭姓是一个古老的姓氏，其来源和含义目前尚不十分明确。但在《廣韻》、《集韻》等古代韵书中，都有对钭字的记载。",
            py2: "dou"
        },
        {
            name: "班",
            py: "bān",
            bihua: "10画",
            wx: "水",
            source: "班字最早出现在西周金文中，其古字形像以刀分玉，意为将玉一分为二，以作信物。班姓可能与这种古代的玉文化有关。",
            py2: "ban"
        },
        {
            name: "仰",
            py: "yǎng 或 áng",
            bihua: "6画",
            wx: "木",
            source: "仰字有多种含义，包括脸向上、敬慕、依靠等。仰姓可能与这些含义有关，但目前具体的出处尚不十分明确。",
            py2: "yang"
        },
        {
            name: "秋",
            py: "qiū",
            bihua: "9画",
            wx: "金",
            source: "秋姓主要源自官位，出自南北朝时期南朝秋卿，属于以官职称号为氏。",
            py2: "qiu"
        },
        {
            name: "仲",
            py: "zhòng",
            bihua: "6画",
            wx: "火",
            source: "仲姓的本义指排行第二，是一个具有悠久历史的姓氏。仲姓的来源可能与古代的排行制度有关。",
            py2: "zhong"
        },
        {
            name: "伊",
            py: "yī",
            bihua: "6画",
            wx: "土",
            source: "伊姓最早见于商代甲骨文，是一个古老的姓氏。关于伊姓的具体来源和含义，目前尚不十分明确。",
            py2: "yi"
        },
        {
            name: "历",
            py: "lì",
            bihua: "4画",
            wx: "火",
            source: "历姓主要源自姜姓，出自先秦的历国，其后以国为氏，称历氏。历姓在中国人口中分布较广，但人数不多。",
            py2: "li"
        },
        {
            name: "戎",
            py: "róng",
            bihua: "6画",
            wx: "木",
            source: "戎姓是一个具有悠久历史的姓氏，其来源有多种说法，包括出自獯鬻族、古戎国以及子姓等。戎姓在中国各地均有分布。",
            py2: "rong"
        },
        {
            name: "祖",
            py: "zǔ",
            bihua: "9画",
            wx: "金",
            source: "祖姓的起源与古代祭祀祖先的礼俗有关，也可能与上古时期的部落首领或官职有关。祖姓在中国人口中分布广泛。",
            py2: "zu"
        },
        {
            name: "武",
            py: "wǔ",
            bihua: "8画",
            wx: "水",
            source: "武姓的起源可以追溯到夏朝时期，其先祖为夏朝大臣武罗。武姓在中国历史上有着重要的地位，出现了许多著名人物。",
            py2: "wu"
        },
        {
            name: "符",
            py: "fú",
            bihua: "11画",
            wx: "木",
            source: "符姓的起源有多种说法，其中包括出自姬姓、鲁顷公后代、北方少数民族改姓等。符姓在中国各地都有分布，是一个具有广泛影响力的姓氏。",
            py2: "fu"
        },
        {
            name: "刘",
            py: "liú",
            bihua: "6画",
            wx: "金",
            source: "刘姓的起源可以追溯到上古的尧帝时期，最早的一支刘姓源自尧的后裔刘累，因此刘累被尊为刘姓的得姓始祖。",
            py2: "liu"
        },
        {
            name: "景",
            py: "jǐng",
            bihua: "12画",
            wx: "木",
            source: "景姓有多个来源，其中一部分源于满族胡锡氏、精格理氏、精吉氏、景佳氏等，后改汉字单姓为景氏。此外，景姓也可能与其他民族的汉化改姓有关。",
            py2: "jing"
        },
        {
            name: "詹",
            py: "zhān",
            bihua: "13画",
            wx: "火",
            source: "詹姓是一个常见的姓氏，但其具体出处目前无法确切追溯，可能与古代的地名或官职有关。",
            py2: "zhan"
        },
        {
            name: "束",
            py: "shù",
            bihua: "7画",
            wx: "金",
            source: "束姓源于妫姓，具体演化过程是妫姓→陈姓→田姓→疏姓→束姓，是一个渊源纯正的汉族姓氏。",
            py2: "shu"
        },
        {
            name: "龙",
            py: "lóng",
            bihua: "5画（繁体16画）",
            wx: "火",
            source: "龙姓与古代的龙图腾和神话传说有关，象征着一种长形、有鳞、有角的神异动物。龙姓在中国人口中分布广泛，具有深厚的文化底蕴。",
            py2: "long"
        },
        {
            name: "叶",
            py: "yè",
            bihua: "5画（繁体12画）",
            wx: "土",
            source: "叶姓的起源与植物的“叶”有关，象征着植物的营养器官之一。叶姓在中国人口中分布广泛，是一个常见的姓氏。",
            py2: "ye"
        },
        {
            name: "幸",
            py: "xìng",
            bihua: "8画",
            wx: "水",
            source: "幸姓有两个来源，一个最初写作“𡴘”，指免去灾祸；另一个最初写作“㚔”，指一种类似手铐的刑具。后来“𡴘”写作“幸”，“㚔”有时也写作“幸”。",
            py2: "xing"
        },
        {
            name: "司",
            py: "sī",
            bihua: "5画",
            wx: "金",
            source: "司字在古代主要指的是主管、操作的含义，如“司法”。这个字在汉字中属于右上包围结构，部首为“口”。司姓作为一个姓氏，其来源和具体出处目前尚不十分明确，可能需要进一步的历史研究和文献资料来揭示。",
            py2: "si"
        },
        {
            name: "韶",
            py: "sháo",
            bihua: "14画",
            wx: "金",
            source: "韶字在汉字中属于二级通用规范汉字，部首为“音”。韶字在古代常用来形容美好的音乐或景色。韶姓作为一个姓氏，其来源和具体出处目前尚不十分明确，可能需要查阅更专业的姓氏研究资料或历史文献来深入了解。",
            py2: "shao"
        },
        {
            name: "郜",
            py: "gào",
            bihua: "9画",
            wx: "木",
            source: "郜姓在古代与古地名有关，指现今中国山东省成武县东南的一个地方。同时，郜也是一个姓氏。关于郜姓的具体来源和演化过程，可能需要查阅姓氏学或历史学的相关资料。",
            py2: "gao"
        },
        {
            name: "黎",
            py: "lí",
            bihua: "15画",
            wx: "火",
            source: "黎字在汉字中属于一级字，部首为“黍”。黎姓是一个常见的姓氏，其来源和具体出处可能涉及多个方面，包括古代的部族、地名等。关于黎姓的详细来源和演化过程，建议查阅专业的姓氏研究资料或历史文献。",
            py2: "li"
        },
        {
            name: "蓟",
            py: "jì",
            bihua: "13画",
            wx: "木",
            source: "蓟姓主要源自姬姓，是一个具有悠久历史的姓氏。在百家姓中，蓟姓的排名因不同版本和时间有所变动，但在一些版本中位于较后的位置。关于蓟姓的具体来源和演化过程，建议查阅姓氏学或历史学的相关资料。",
            py2: "ji"
        },
        {
            name: "薄",
            py: "báo 或 bó 或 bò",
            bihua: "16画",
            wx: "水",
            source: "薄姓是一个多音字姓氏，其起源与古代的官职、地名以及少数民族的汉化改姓有关。在古代，“薄”字常用于形容物体的厚度、浓度等属性，后逐渐演化为姓氏。",
            py2: "bo"
        },
        {
            name: "印",
            py: "yìn",
            bihua: "5画",
            wx: "水",
            source: "印姓的起源与古代的印章文化有关。印章在古代是一种权力的象征，也是身份的证明，因此以印为姓，可能寓意着对权力、地位的追求。印姓在百家姓中排名第265位，其代表人物有印宝、印应雷等。",
            py2: "yin"
        },
        {
            name: "宿",
            py: "sù 或 xu",
            bihua: "11画",
            wx: "金",
            source: "宿姓的起源有多个说法，其中之一是出自风姓，是上古伏羲氏的后代，以国名为氏。宿姓在中国人口中分布较广，其代表人物有宿云龙、宿茂臻等。",
            py2: "su"
        },
        {
            name: "白",
            py: "bái",
            bihua: "5画",
            wx: "金",
            source: "白姓的起源与古代的颜色文化有关。白色在古代常被视为纯洁、明亮的象征，因此以白为姓，可能寓意着对纯洁、明亮品质的向往。白姓在汉字中也是部首之一，序号112，其代表人物众多，如白居易等。",
            py2: "bai"
        },
        {
            name: "怀",
            py: "huái",
            bihua: "7画",
            wx: "水",
            source: "怀姓的起源有多个说法，可能源自子姓、隗姓、芈姓或无怀氏的后代。怀姓在百家姓中的排名较后，但其代表人物如怀能、怀叙、怀进鹏等，都在各自的领域有着显著的成就。",
            py2: "huai"
        },
        {
            name: "蒲",
            py: "pú",
            bihua: "13画",
            wx: "木",
            source: "蒲姓的起源与古代的植物有关，指的是一种多年生草本植物，生池沼中，高近两米。根茎长在泥里，可食。叶长而尖，可编席、造纸。因此以蒲为姓，可能寓意着对这种植物的喜爱或与之相关的历史背景。蒲姓在汉字中也是常用字，其代表人物众多。",
            py2: "pu"
        },
        {
            name: "邰",
            py: "tái",
            bihua: "7画",
            wx: "火",
            source: "邰姓的起源与周族始祖弃（后稷）有关。据《说文》记载，后稷为尧的大司农，以功受封于邰这个地方，子孙就以邰为姓氏。因此，邰姓具有深厚的历史文化底蕴。",
            py2: "tai"
        },
        {
            name: "从",
            py: "cóng",
            bihua: "4画",
            wx: "火",
            source: "从姓的起源可能与古代的从属关系或随从职业有关，但目前具体出处尚不十分明确。",
            py2: "cong"
        },
        {
            name: "鄂",
            py: "è",
            bihua: "11画",
            wx: "木",
            source: "鄂姓的起源有多个说法，其中之一是出自姞姓，为黄帝姞姓后裔，以国名为姓。另外，也有说法认为鄂姓与古代的鄂州（今湖北鄂州）有关。",
            py2: "e"
        },
        {
            name: "索",
            py: "suǒ",
            bihua: "10画",
            wx: "金",
            source: "索姓的起源与古代的绳索制作或相关职业有关，也可能与少数民族的汉化改姓有关。索姓在中国人口中分布较广，其代表人物有索靖等。",
            py2: "suo"
        },
        {
            name: "咸",
            py: "xián",
            bihua: "9画",
            wx: "水",
            source: "咸姓的起源可能与古代的咸国或咸地有关，但目前具体出处尚不十分明确。咸姓在中国人口中分布较为广泛。",
            py2: "xian"
        },
        {
            name: "籍",
            py: "jí",
            bihua: "20画",
            wx: "木",
            source: "籍姓的起源可能与古代的户籍制度或书籍编纂有关，但目前具体出处尚不十分明确。籍姓在中国人口中分布较为分散。",
            py2: "ji"
        },
        {
            name: "赖",
            py: "lài",
            bihua: "8画",
            wx: "火",
            source: "赖姓最早见于《说文》中的小篆文字，其本义为赢利、利益，又可引申为依赖、依靠。",
            py2: "lai"
        },
        {
            name: "卓",
            py: "zhuó",
            bihua: "8画",
            wx: "火",
            source: "卓姓有多个来源。一种说法是，战国时期，姬同为肇国中大夫，后为避秦国因荆柯之事引发的屠杀燕国贵族之难，改以父亲姬质成封地“涿”的谐音字“卓”为姓氏，称卓同。卓姓后世子孙多以先祖封邑名称改谐音字为姓氏，称卓氏，世代相传至今。另一种说法是，卓姓源于西周国初期周武王属下功臣卓异，其后代以先祖名字为氏。",
            py2: "zhuo"
        },
        {
            name: "蔺",
            py: "lìn",
            bihua: "14画",
            wx: "木",
            source: "蔺字指多年生草本植物，茎细圆而长，中有白髓。作为姓氏，蔺姓的具体起源目前尚不十分明确。",
            py2: "lin"
        },
        {
            name: "屠",
            py: "tú",
            bihua: "11画",
            wx: "火",
            source: "屠姓最早见于《说文》小篆，其本义是宰杀牲畜，引申为屠杀，又可指分裂、以宰杀牲畜为职业的人等。作为姓氏，屠姓的具体起源目前尚不十分明确。",
            py2: "tu"
        },
        {
            name: "蒙",
            py: "méng",
            bihua: "13画",
            wx: "水",
            source: "蒙姓有多个来源。据史籍《清朝通志·氏族略·满洲八旗姓》、《八旗通志》记载，满族蒙古氏源于金国时期女真蒙古部，后归附蒙古汗国，改姓为蒙古氏，满语为Monggu Hala。后世子孙多冠汉姓为蒙氏、孟氏、银氏等。此外，蒙姓还有其他来源，但具体出处需进一步查证。",
            py2: "meng"
        },
        {
            name: "池",
            py: "chí",
            bihua: "6画",
            wx: "水",
            source: "池字的基本解释是水塘，多指人工挖的。作为姓氏，池姓的具体起源目前尚不十分明确。",
            py2: "chi"
        },
        {
            name: "乔",
            py: "qiáo",
            bihua: "6画",
            wx: "木",
            source: "乔字始见于西周金文，其本义是高耸，常形容树木高大的样子。作为姓氏，乔姓的具体起源目前尚不十分明确。",
            py2: "qiao"
        },
        {
            name: "阳",
            py: "yáng",
            bihua: "6画",
            wx: "土",
            source: "阳姓的起源与古代的阳地、阳国或阳氏封邑有关，但目前具体出处尚不十分明确。",
            py2: "yang"
        },
        {
            name: "胥",
            py: "xū",
            bihua: "9画",
            wx: "金",
            source: "胥姓的起源可能与古代的官职“胥”有关，是掌管文书的小吏，后逐渐演化为姓氏。",
            py2: "xu"
        },
        {
            name: "能",
            py: "néng",
            bihua: "10画",
            wx: "火",
            source: "能姓的起源尚不十分明确，可能与古代的职业、技能或地名有关。",
            py2: "neng"
        },
        {
            name: "苍",
            py: "cāng",
            bihua: "7画",
            wx: "木",
            source: "苍姓的起源可能与古代的青色或苍色有关，也可能与地名或官职有关，但目前具体出处尚不十分明确。",
            py2: "cang"
        },
        {
            name: "双",
            py: "shuāng",
            bihua: "4画",
            wx: "金",
            source: "双姓的起源可能与古代的双胞胎、双重意义或地名有关，但目前具体出处尚不十分明确。",
            py2: "shuang"
        },
        {
            name: "闻",
            py: "wén",
            bihua: "9画",
            wx: "水",
            source: "闻姓的起源可能与古代的听闻、传达或地名有关，但目前具体出处尚不十分明确。",
            py2: "wen"
        },
        {
            name: "莘",
            py: "shēn",
            bihua: "10画",
            wx: "木",
            source: "莘姓的起源可能与古代的莘地或莘国有关，但目前具体出处尚不十分明确。",
            py2: "shen"
        },
        {
            name: "党",
            py: "dǎng 或 zhǎng",
            bihua: "8画",
            wx: "火",
            source: "党姓有两个主要的来源。一是源于西羌的血统，与古代的党项族有关。另一是源于姬姓，出自春秋时期晋国公族大夫的封地。此外，也有部分党姓源于任姓，出自春秋时期的鲁国之邑阙党。",
            py2: "dang"
        },
        {
            name: "翟",
            py: "dí 或 zhái",
            bihua: "14画",
            wx: "土",
            source: "翟姓原音为狄，至唐时改音为宅（Zhái）。翟姓由于各地方言不同，形成了两种读音，居于北方者读（Dí），迁居南方者读（Zhái）。",
            py2: "zhai"
        },
        {
            name: "谭",
            py: "tán",
            bihua: "14画",
            wx: "火",
            source: "谭姓起源于周初的谭国，为姒姓诸侯国，后被齐桓公吞并。谭国的子孙以国为氏，称谭氏。谭姓的郡望为弘农郡、济阳郡，主要的堂号为善断堂、济阳堂等。谭姓在中国人口中分布广泛，尤其在山东、湖南、广东等地较为常见。",
            py2: "tan"
        },
        {
            name: "贡",
            py: "gòng",
            bihua: "10画",
            wx: "木",
            source: "贡姓的得姓始祖是子贡，他是孔子的弟子，以言行为贤而著称。因此，贡姓与孔子及其儒家思想有着深厚的渊源。",
            py2: "gong"
        },
        {
            name: "劳",
            py: "láo",
            bihua: "7画",
            wx: "火",
            source: "劳姓是一个常见的姓氏，其起源可能与古代的劳动、功劳或地名有关。劳字在汉字中有多重含义，包括疲劳、劳累、功劳、功绩等。",
            py2: "lao"
        },
        {
            name: "逄",
            py: "páng",
            bihua: "9画",
            wx: "水",
            source: "逄姓是一个较为罕见的姓氏，其起源目前尚不十分明确。在汉字中，“逄”字多用于姓氏，并无具体的出处记载。",
            py2: "pang"
        },
        {
            name: "姬",
            py: "jī",
            bihua: "9画",
            wx: "木",
            source: "姬姓是一个古老的姓氏，其起源与上古的母系社会有关。据《国语·晋语》记载，黄帝的二十五个儿子，其中得姓者十四人，为十二姓，姬姓便是其中之一。此外，姬姓也是周朝的国姓，周朝的始祖后稷为姬姓。",
            py2: "ji"
        },
        {
            name: "申",
            py: "shēn",
            bihua: "5画",
            wx: "金",
            source: "申姓的起源主要有三：一是源于姜姓，出自周朝时期申国，属于以国名为氏；二是源于朝鲜族，属于汉化改姓为氏；三是源于蒙古族和傈僳族，也属于汉化改姓为氏。申姓在中华姓氏中属于老资格的名门著姓。",
            py2: "shen"
        },
        {
            name: "扶",
            py: "fú",
            bihua: "7画",
            wx: "水",
            source: "扶字在汉字中主要表示搀扶、帮助的意思，作为姓氏，其起源和具体出处目前尚不十分明确。",
            py2: "fu"
        },
        {
            name: "堵",
            py: "dǔ",
            bihua: "11画",
            wx: "土",
            source: "堵姓出自春秋时期郑国的公族，始祖堵叔是圣君周文王的后裔。堵原是一个地名，是郑国大夫洩伯的采邑，他的后代以邑为氏，世称堵氏，望族出于河南。",
            py2: "du"
        },
        {
            name: "冉",
            py: "rǎn",
            bihua: "5画",
            wx: "火",
            source: "冉姓的起源目前尚不十分明确，可能与古代的官职、地名或民族有关。",
            py2: "ran"
        },
        {
            name: "宰",
            py: "zǎi",
            bihua: "6画",
            wx: "金",
            source: "宰姓有多个来源，其中一个主要的来源是源于官位，出自殷商王朝官吏宰，属于以官职称谓为氏。此外，宰姓也可能与古代的其他官职、地名或民族有关。",
            py2: "zai"
        },
        {
            name: "郦",
            py: "lì",
            bihua: "9画",
            wx: "火",
            source: "郦姓的起源主要与地名有关，古时的郦县是郦姓的发源地。此外，郦姓也可能与古代的官职或其他因素有关。",
            py2: "li"
        },
        {
            name: "雍",
            py: "yōng",
            bihua: "6画",
            wx: "土",
            source: "雍姓有多个起源，其中之一是出自西周时期官吏雍人，属于以官职称谓为氏；另一个是出自姬姓，是3000多年前周朝王室的后裔，得姓始祖是周文王的第十三个儿子雍伯。此外，雍姓也可能与满族或其他民族有关。",
            py2: "yong"
        },
        {
            name: "却",
            py: "què",
            bihua: "7画",
            wx: "木",
            source: "却字在汉字中主要表示退、拒绝等意思。作为姓氏，却姓的起源和具体出处目前尚不十分明确，但确实存在却姓的人群。",
            py2: "que"
        },
        {
            name: "璩",
            py: "qú",
            bihua: "17画",
            wx: "木",
            source: "璩姓起源于古代的璩器，一种古代的耳环或玉器。同时，璩也是古代的姓氏之一，据《通志·氏族略》记载，璩姓是晋大夫姬璩的后代。",
            py2: "qu"
        },
        {
            name: "桑",
            py: "sāng",
            bihua: "10画",
            wx: "木",
            source: "桑姓的起源可能与古代的桑树或桑蚕业有关。桑树在古代是重要的经济作物，桑蚕业也是古代的重要产业，因此可能有人以桑为姓。",
            py2: "sang"
        },
        {
            name: "桂",
            py: "guì",
            bihua: "10画",
            wx: "木",
            source: "桂姓的起源与桂树或桂花有关，可能是以植物为姓。同时，桂姓也可能是古代一些少数民族的姓氏，经过历史的演变而成为汉族的姓氏之一。",
            py2: "gui"
        },
        {
            name: "濮",
            py: "pú",
            bihua: "17画",
            wx: "水",
            source: "濮姓的起源与古代的濮水有关，濮水是古代的一条河流，居住在濮水附近的人可能以濮为姓。此外，濮姓也可能是古代少数民族的姓氏，经过历史的演变而成为汉族的姓氏之一。",
            py2: "pu"
        },
        {
            name: "牛",
            py: "niú",
            bihua: "4画",
            wx: "木",
            source: "牛姓的起源与古代的牛有关，可能是以动物为姓。在古代，牛是重要的劳动力，因此有人以牛为姓。此外，牛姓也可能是古代少数民族的姓氏，经过历史的演变而成为汉族的姓氏之一。牛姓还有一些其他的来源，比如满族哈萨喇氏、额哲氏、牛佳氏等改汉姓为牛。",
            py2: "niu"
        },
        {
            name: "寿",
            py: "shòu",
            bihua: "7画",
            wx: "金",
            source: "寿姓的起源与寿命、长寿有关，可能是以寿命为姓。此外，寿姓也是吴国王室的后代，据《风俗通》记载，寿姓的始祖是春秋时期的吴王寿梦。",
            py2: "shou"
        },
        {
            name: "通",
            py: "tōng",
            bihua: "10画",
            wx: "火",
            source: "通姓的起源可能与古代的通路、通道有关，居住在交通要道附近的人可能以通为姓。此外，通姓也可能是古代少数民族的姓氏，经过历史的演变而成为汉族的姓氏之一。",
            py2: "tong"
        },
        {
            name: "边",
            py: "biān",
            bihua: "5画",
            wx: "水",
            source: "边姓的起源与古代的边疆、边境有关，可能是以地域为姓。在古代，边疆地区是国家的边缘地带，因此有人以边为姓。此外，边姓也可能是古代少数民族的姓氏，经过历史的演变而成为汉族的姓氏之一。",
            py2: "bian"
        },
        {
            name: "扈",
            py: "hù",
            bihua: "11画",
            wx: "水",
            source: "扈姓的起源目前尚不十分明确，可能与古代的扈国或扈邑有关。此外，扈姓也可能是古代少数民族的姓氏，经过历史的演变而成为汉族的姓氏之一。",
            py2: "hu"
        },
        {
            name: "燕",
            py: "yàn",
            bihua: "16画",
            wx: "土",
            source: "燕姓的起源与古代的燕国有关，燕国是周朝时期的一个诸侯国，其国民以国名为姓。此外，燕姓也可能是古代少数民族的姓氏，经过历史的演变而成为汉族的姓氏之一。同时，燕姓也可能与燕子这种鸟类有关，古人常以鸟类为姓。",
            py2: "yan"
        },
        {
            name: "冀",
            py: "jì",
            bihua: "16画",
            wx: "木",
            source: "冀姓源出有三，相传唐尧的后代，在西周时有被封在冀亭（今山西省河津市）的，即建立冀国，其后代以国名为姓。",
            py2: "ji"
        },
        {
            name: "郏",
            py: "jiá",
            bihua: "8画",
            wx: "水",
            source: "郏姓出自春秋时期的郑国，以地名为氏。根据《元和姓纂》的记载，周成王定鼎于郏，定居在这个地方的人就以郏为姓氏。",
            py2: "jia"
        },
        {
            name: "浦",
            py: "pǔ",
            bihua: "10画",
            wx: "水",
            source: "浦字本身具有水滨的含义，但作为一个姓氏，其具体的起源和出处目前尚不十分明确。",
            py2: "pu"
        },
        {
            name: "尚",
            py: "shàng",
            bihua: "8画",
            wx: "金",
            source: "尚姓是一个常见的姓氏，其起源可能与古代的官职、地位或美德有关。在汉字中，“尚”字有崇尚、尊重的含义，因此尚姓也可能与这些概念有关。",
            py2: "shang"
        },
        {
            name: "农",
            py: "nóng",
            bihua: "9画",
            wx: "火",
            source: "农姓的起源可能与古代的农业活动有关。在古代社会，农业是主要的生产方式，因此有人以农为姓，表示对农业的依赖和尊重。",
            py2: "nong"
        },
        {
            name: "温",
            py: "wēn",
            bihua: "12画",
            wx: "土",
            source: "温姓有多个起源。一是源于己姓，出自颛顼帝高阳氏的后裔夏朝大臣平的封地，属于以封邑名称为氏；二是源于姬姓，出自春秋时期晋国大夫郤至的封地；三是源于鲜卑族，出自南北朝时期鲜卑拓拔部，属于文化上汉化改姓为氏。",
            py2: "wen"
        },
        {
            name: "别",
            py: "bié",
            bihua: "7画",
            wx: "水",
            source: "别姓起源于西周时期的别子，别子是周初两次封建（封疆土，建诸侯）的产物。其发源地在陕西古长安京畿邠州地域，即现西安市西北一带。",
            py2: "bie"
        },
        {
            name: "庄",
            py: "zhuāng",
            bihua: "6画",
            wx: "金",
            source: "庄字在汉字中是一个常见的字，其基本义是严肃、庄重。作为姓氏，庄姓的起源较为久远，始见于战国文字，可能产生时间更早。庄姓的基本含义是大路，引申转指庄园、村庄。在古代，庄也用来指有较大规模或作批发生意的商店。",
            py2: "zhuang"
        },
        {
            name: "晏",
            py: "yàn",
            bihua: "10画",
            wx: "土",
            source: "晏字在汉字中的本义是指晴朗的天气。作为姓氏，晏姓的具体起源和出处目前尚不十分明确，但它在汉语中是一个二级字，属于较常见的姓氏之一。",
            py2: "yan"
        },
        {
            name: "柴",
            py: "chái",
            bihua: "7画",
            wx: "木",
            source: "柴姓的起源有多个方面。一部分柴姓源于炎帝的姜姓，另一部分则出自春秋时期齐文公世孙高柴，属于以先祖名字为氏。此外，据《清朝通志·氏族略·满洲八旗姓》记载，满族赛密哷氏也有改汉字姓为柴氏的。",
            py2: "chai"
        },
        {
            name: "瞿",
            py: "qú",
            bihua: "18画",
            wx: "木",
            source: "瞿字在汉字中是一个二级通用规范汉字，本义指像鹰隼一样地惊视，又引申为人惊恐回顾的样子。作为姓氏，瞿姓始见于战国，由“隹”和“䀠（jù）”组成。",
            py2: "qu"
        },
        {
            name: "阎",
            py: "yán",
            bihua: "10画",
            wx: "木",
            source: "阎字在汉字中的基本解释是里巷的门，亦指里巷。作为姓氏，阎姓可能与古代的里巷、城门等地域概念有关。阎姓在汉字中属于上三包围结构，其部首是“门”。",
            py2: "yan"
        },
        {
            name: "充",
            py: "chōng",
            bihua: "6画",
            wx: "通常认为属土（但五行属性可能因不同资料或学派而有所差异）",
            source: "充作为姓氏，目前尚无确切的起源记载。在汉字中，充的本义指长、高，可能与古代的某些地名、官职或人物有关。",
            py2: "chong"
        },
        {
            name: "慕",
            py: "mù",
            bihua: "14画",
            wx: "通常认为属水（但五行属性可能因不同资料或学派而有所差异）",
            source: "慕姓在《玉篇·心部》中有记载，意为“思也”，表明慕姓可能与思考、向往等情感有关。",
            py2: "mu"
        },
        {
            name: "连",
            py: "lián",
            bihua: "7画",
            wx: "火",
            source: "连姓主要源自芈姓，是一个有着深厚历史背景的姓氏。",
            py2: "lian"
        },
        {
            name: "茹",
            py: "rú",
            bihua: "9画",
            wx: "通常认为属木（但五行属性可能因不同资料或学派而有所差异）",
            source: "茹姓作为一个常见的姓氏，目前尚无法确定其确切的起源。",
            py2: "ru"
        },
        {
            name: "习",
            py: "xí",
            bihua: "8画",
            wx: "通常认为属水（但五行属性可能因不同资料或学派而有所差异）",
            source: "习姓有两个主要的得姓始祖，习响和息夫躬。习姓的起源与古代的国名、地名有关。",
            py2: "xi"
        },
        {
            name: "宦",
            py: "huàn",
            bihua: "9画",
            wx: "通常认为属水（但五行属性可能因不同资料或学派而有所差异）",
            source: "宦姓是一个有着悠久历史的姓氏，但目前尚无法确定其确切的起源。",
            py2: "huan"
        },
        {
            name: "艾",
            py: "ài（也可读作yì，但较为少见）",
            bihua: "5画（按ài读音计算）",
            wx: "通常认为属土（但五行属性可能因不同资料或学派而有所差异）",
            source: "艾姓的起源可能与古代的艾草或地名有关，是一个具有丰富文化内涵的姓氏。",
            py2: "ai"
        },
        {
            name: "鱼",
            py: "yú",
            bihua: "8画",
            wx: "水",
            source: "鱼字是汉字中的一个常用字，基本含义是指生活在水中、有鳞和鳍、用鳃呼吸的脊椎动物。作为姓氏，鱼姓的起源可能与古代的渔业文化、水域居住者或者与鱼相关的地名有关。",
            py2: "yu"
        },
        {
            name: "容",
            py: "róng",
            bihua: "10画",
            wx: "土",
            source: "容字在汉字中有多重含义，包括容纳、包容、仪容等。作为姓氏，容姓的起源可能与古代的官职、地名或者人物有关，但目前确切的起源尚待考证。",
            py2: "rong"
        },
        {
            name: "向",
            py: "xiàng",
            bihua: "6画",
            wx: "水",
            source: "向姓是一个古老的姓氏，其起源可能与古代的地名、官职或者人物有关。据《姓氏考略》记载，向姓出自姜姓，为炎帝神农氏之后。炎帝裔孙向垚封于向地（今山东济宁），后代以国为氏，就是向氏。",
            py2: "xiang"
        },
        {
            name: "古",
            py: "gǔ",
            bihua: "5画",
            wx: "木",
            source: "古姓是一个古老而多源的姓氏，最早来源于周文王姬昌的祖父古公亶父。古姓族群也是一个古老、多民族、多源流的姓氏群体。",
            py2: "gu"
        },
        {
            name: "易",
            py: "yì",
            bihua: "8画",
            wx: "火",
            source: "易字在汉字中表示简单、变化等含义。作为姓氏，易姓的起源可能与古代的官职、地名或者人物有关。易姓在中国历史上是一个较为常见的姓氏，有着悠久的历史和深厚的文化底蕴。",
            py2: "yi"
        },
        {
            name: "慎",
            py: "shèn",
            bihua: "13画",
            wx: "金",
            source: "慎字在汉字中主要表示小心、谨慎的含义。作为姓氏，慎姓的起源可能与古代的官职、地名或者美德有关。慎姓虽然不是特别常见，但在历史上也有一些著名的人物姓慎，为这一姓氏增添了光彩。",
            py2: "shen"
        },
        {
            name: "戈",
            py: "gē",
            bihua: "4画",
            wx: "通常认为属金（但五行属性可能因不同资料或学派而有所差异）",
            source: "戈作为姓氏，可能与其作为古代兵器的原始含义有关。戈字在汉字中是一个象形字，表示一种古代长柄横刃的兵器。",
            py2: "ge"
        },
        {
            name: "廖",
            py: "liào",
            bihua: "14画",
            wx: "火",
            source: "廖姓是一个历史悠久的姓氏，其来源可能与古代的官职、地名或人物有关。廖姓在《百家姓》中有收录，是一个较为常见的姓氏。",
            py2: "liao"
        },
        {
            name: "庾",
            py: "yǔ",
            bihua: "11画",
            wx: "通常认为属木（但五行属性可能因不同资料或学派而有所差异）",
            source: "庾姓源出有二，一出自颛顼高阳氏，以官名为氏；另一来源是出自以封地名为姓。",
            py2: "yu"
        },
        {
            name: "终",
            py: "zhōng",
            bihua: "8画",
            wx: "通常认为属火（但五行属性可能因不同资料或学派而有所差异）",
            source: "终姓作为一个姓氏，其来源目前尚无确切记载。在汉字中，终字有多重含义，包括结束、终止等。",
            py2: "zhong"
        },
        {
            name: "暨",
            py: "jì",
            bihua: "14画",
            wx: "通常认为属木（但五行属性可能因不同资料或学派而有所差异）",
            source: "暨字在汉字中表示连接、合并的含义。作为姓氏，暨姓的起源可能与古代的地理、官职或人物有关。",
            py2: "ji"
        },
        {
            name: "居",
            py: "jū",
            bihua: "5画",
            wx: "通常认为属木（但五行属性可能因不同资料或学派而有所差异）",
            source: "居姓是一个较为罕见的姓氏，其来源可能与古代的官职、地名或人物有关。",
            py2: "ju"
        },
        {
            name: "衡",
            py: "héng",
            bihua: "16画",
            wx: "通常认为属土（但五行属性可能因不同资料或学派而有所差异）",
            source: "衡姓有多个来源，可能源于地名（如春秋时期郑国城邑雍雝），也可能与满族姓氏的改姓有关。",
            py2: "heng"
        },
        {
            name: "步",
            py: "bù",
            bihua: "7画",
            wx: "通常认为属水（但五行属性可能因不同资料或学派而有所差异）",
            source: "步姓的始祖是步扬，至于步姓更详细的起源和演化过程，建议查阅姓氏学相关书籍或资料。",
            py2: "bu"
        },
        {
            name: "都",
            py: "dū",
            bihua: "10画",
            wx: "火",
            source: "都字在汉字中有多重含义，包括大都市、全部、完全等。作为姓氏，都姓的起源可能与古代的地理、官职或人物有关，但具体出处尚待考证。",
            py2: "du"
        },
        {
            name: "耿",
            py: "gěng",
            bihua: "10画",
            wx: "通常认为属火（但五行属性可能因不同资料或学派而有所差异）",
            source: "耿姓的起源目前尚不十分明确，但在汉字中，耿字与光明、正直等含义有关，可能反映了耿姓族群的某些特质或价值观。",
            py2: "geng"
        },
        {
            name: "满",
            py: "mǎn",
            bihua: "13画",
            wx: "水",
            source: "满姓的起源可能与古代的满族有关，满族是中国的一个少数民族，有着自己的历史和文化传统。满姓也可能与古代的地名、官职或人物有关，具体出处需要进一步研究。",
            py2: "man"
        },
        {
            name: "弘",
            py: "hóng",
            bihua: "5画",
            wx: "水",
            source: "弘字在汉字中表示广大、弘大等含义。作为姓氏，弘姓的起源可能与古代的官职、地名或人物有关，但具体出处尚待考证。弘姓在历史上也有一些著名人物，为这一姓氏增添了光彩。",
            py2: "hong"
        },
        {
            name: "匡",
            py: "kuāng",
            bihua: "6画",
            wx: "木",
            source: "匡姓的来源可能有多个，但具体出处尚待考证。在汉字中，匡字有纠正、辅助的含义，可能反映了匡姓族群的某些特质或价值观。",
            py2: "kuang"
        },
        {
            name: "国",
            py: "guó",
            bihua: "8画",
            wx: "木",
            source: "国姓的起源较为多样，部分出自姜姓，以官称为氏；部分出自姬姓，以祖字为氏。在宋版《百家姓》中，国姓排在第354位。",
            py2: "guo"
        },
        {
            name: "文",
            py: "wén",
            bihua: "4画",
            wx: "水",
            source: "文姓的来源主要有两支，一支源于姬姓，为周文王姬昌后裔；另一支出于姜姓，为炎帝后裔四岳氏之后。文姓在中国人口较多，排名第107位。",
            py2: "wen"
        },
        {
            name: "寇",
            py: "kòu",
            bihua: "11画",
            wx: "木",
            source: "寇姓的起源可能与古代的入侵者、盗匪有关，因为寇字在汉字中有入侵、侵犯的含义。作为姓氏，寇姓可能反映了古代某些族群的生活状态或历史背景。",
            py2: "kou"
        },
        {
            name: "广",
            py: "guǎng",
            bihua: "3画",
            wx: "木",
            source: "广姓可能源于古代的广武地名，后来人们以广武为姓，简化成广姓。这一姓氏可能与古代的地理、官职或人物有关。",
            py2: "guang"
        },
        {
            name: "禄",
            py: "lù",
            bihua: "12画",
            wx: "火",
            source: "禄姓的起源有多种说法，包括以祖字为氏、以地名为氏等。禄姓族群在历史上有着丰富的文化和传统，为中华民族的发展做出了贡献。",
            py2: "lu"
        },
        {
            name: "阙",
            py: "quē",
            bihua: "13画",
            wx: "金",
            source: "阙姓是一个较为罕见的姓氏，其来源可能与古代的阙里（即孔子故里曲阜）、阙党或阙门有关。阙姓在《百家姓》中排名第359位。",
            py2: "que"
        },
        {
            name: "东",
            py: "dōng",
            bihua: "5画",
            wx: "木",
            source: "东姓的起源尚不十分明确，可能与古代的地理方位、官职或人物有关。在汉字中，东字表示方向，可能反映了东姓族群的某些特质或历史背景。",
            py2: "dong"
        },
        {
            name: "殳",
            py: "shū",
            bihua: "7画",
            wx: "通常认为属金（但五行属性可能因不同资料或学派而有所差异）",
            source: "殳姓是中国姓氏之一，在宋版《百家姓》中排序为第三百六十二位。主要分布在江苏、浙江、安徽等地，历史上有一些著名人物，如清代才女殳默、孝子殳帮清等。",
            py2: "shu"
        },
        {
            name: "沃",
            py: "wò",
            bihua: "7画",
            wx: "水",
            source: "沃姓的汉字本义指把水从上浇下。关于其作为姓氏的起源，目前尚未有确切的资料，可能源于古代的某个地名、官职或人物。",
            py2: "wo"
        },
        {
            name: "利",
            py: "lì",
            bihua: "7画",
            wx: "火",
            source: "利姓的起源有多种说法。其中，一种说法是源于嬴姓，出自春秋时秦国大夫公孙鞅之后。另一种说法是源于姬姓，出自春秋时期晋国大夫姬姓利氏之后。利姓在历史上也有其代表人物，如西汉丞相利苍等。",
            py2: "li"
        },
        {
            name: "谯",
            py: "qiáo",
            bihua: "14画",
            wx: "金",
            source: "谯姓的起源可能与古代的谯楼（古代城门上建的楼，可以瞭望）有关。谯姓在历史上虽然不是一个非常常见的姓氏，但也有一些著名的人物。",
            py2: "qiao"
        },
        {
            name: "虎",
            py: "hǔ",
            bihua: "8画",
            wx: "水",
            source: "虎姓的起源可以追溯到上古时期的“八元”之一伯虎的后人。虎姓在历史上的分布和发展，与当时的社会、文化和地理环境等因素密切相关。",
            py2: "hu"
        },
        {
            name: "须",
            py: "xū",
            bihua: "9画",
            wx: "金",
            source: "须姓的起源可以追溯到周朝初期太昊伏羲氏裔孙的封地，他们以国名为姓，因此有了须姓。据史籍《名贤氏族言行类稿》记载：“须，出太昊伏曦氏风姓后裔，有须句国。”",
            py2: "xu"
        },
        {
            name: "奉",
            py: "fèng",
            bihua: "8画",
            wx: "水",
            source: "奉姓的起源有多种说法，其中一种说法是奉姓源出嬴姓，出自秦献公第二子嬴季昌，属于避乱改姓为氏。另一种说法是奉姓源于汉封奉春君，后以官为姓。奉姓在湖南、四川、广西、安徽、重庆等地都有分布。",
            py2: "feng"
        },
        {
            name: "承",
            py: "chéng",
            bihua: "8画",
            wx: "通常认为属金（但五行属性可能因不同资料或学派而有所差异）",
            source: "承姓是一个较为古老的姓氏，其起源尚不十分明确。在汉字中，承字有多重含义，包括接受、继承等，可能反映了承姓族群的某些特质或历史背景。承姓在历史上的分布和发展，与当时的社会、文化和地理环境等因素密切相关。",
            py2: "cheng"
        },
        {
            name: "真",
            py: "zhēn",
            bihua: "10画",
            wx: "金",
            source: "真姓的起源可以追溯到夏朝时期的大禹的辅佐臣子真窥。据《吕氏春秋·慎行论·壹行》记载，真窥是大禹的五佐臣之一，其后代以祖名为姓，形成了真姓。",
            py2: "zhen"
        },
        {
            name: "宇",
            py: "yǔ",
            bihua: "6画",
            wx: "土",
            source: "宇姓的来源之一可以追溯到周宣王的母舅申伯，他被封为申国之伯和周卿士，其后有宇氏。",
            py2: "yu"
        },
        {
            name: "巢",
            py: "cháo",
            bihua: "11画",
            wx: "金",
            source: "巢姓的起源与上古时期的巢氏部落有关，巢姓属于以国名、氏族名称为氏的姓氏。",
            py2: "chao"
        },
        {
            name: "羌",
            py: "qiāng",
            bihua: "7画（简体）；8画（繁体）",
            wx: "木",
            source: "羌姓并非直接从羌族而来，而可能是一个古老的姓氏，其含义与古代的羌族文化或历史背景有关。",
            py2: "qiang"
        },
        {
            name: "相",
            py: "xiàng",
            bihua: "9画",
            wx: "木",
            source: "相姓的起源与商朝有关。商中宗迁都后，留居在原相城的商族人便以故都名称为姓氏，称为相氏。",
            py2: "xiang"
        },
        {
            name: "辜",
            py: "gū",
            bihua: "10画",
            wx: "金",
            source: "辜姓的起源与子姓有关，其得姓始祖包括林正（林达中）和陈敦源。",
            py2: "gu"
        },
        {
            name: "展",
            py: "zhǎn",
            bihua: "10画",
            wx: "火",
            source: "展姓作为一个常见的姓氏，其起源尚未有确切的资料，可能源于古代的某个地名、官职或人物。",
            py2: "zhan"
        },
        {
            name: "丑",
            py: "chǒu",
            bihua: "4画",
            wx: "火",
            source: "丑姓的起源目前尚未有明确的资料，可能源于古代的某种特征、地名或官职。丑字在汉字中有多重含义，可能与丑姓的起源和含义有关。",
            py2: "chou"
        },
        {
            name: "银",
            py: "yín",
            bihua: "11画",
            wx: "金",
            source: "银姓的起源与古代的金属银有关，也可能与古代的官职、地名或人物有关。在汉字中，银字表示一种贵重的金属，因此银姓可能反映了其族群的某些特质或历史背景。",
            py2: "yin"
        },
        {
            name: "丰",
            py: "fēng",
            bihua: "4画",
            wx: "火",
            source: "丰姓有多个起源，其中之一是源于姬姓，春秋时期郑穆公的儿子公子丰的后代以丰为姓。另一个起源是周文王的第十七子封于酆国（今陕西省户县东），后人以国名为姓，称为酆氏，后来部分后人取酆字的左边为姓，即丰字为姓。",
            py2: "feng"
        },
        {
            name: "矫",
            py: "jiǎo、qiáo",
            bihua: "9画",
            wx: "木",
            source: "矫姓源于姬姓，出自春秋时期晋国大夫矫父之后，属于以先祖名字为氏。此外，矫姓也可能与姒姓有关。",
            py2: "jiao"
        },
        {
            name: "上",
            py: "shàng",
            bihua: "3画",
            wx: "金",
            source: "上姓在汉字中有多重含义，如大姓（指望族的姓氏）或问人姓氏的敬词（犹言贵姓）。其作为姓氏的起源目前尚不十分明确。",
            py2: "shang"
        },
        {
            name: "绳",
            py: "shéng",
            bihua: "11画",
            wx: "金",
            source: "绳姓出自子姓，源于商王之后，是一个具有深厚历史背景的姓氏。",
            py2: "sheng"
        },
        {
            name: "城",
            py: "chéng",
            bihua: "9画",
            wx: "土",
            source: "城姓的得姓始祖包括郕叔武（姬武）、公子寿（子寿）、城浑、班倢伃等，其来源与地名有关。",
            py2: "cheng"
        },
        {
            name: "舍",
            py: "shè、shě",
            bihua: "8画",
            wx: "金",
            source: "舍姓作为一个姓氏，其起源和具体含义目前尚不十分明确，可能源于古代的官职、地名或人物。",
            py2: "she"
        },
        {
            name: "郅",
            py: "zhì",
            bihua: "8画",
            wx: "火",
            source: "郅姓的起源目前尚不十分明确，可能源于古代的官职、地名或人物。",
            py2: "zhi"
        },
        {
            name: "布",
            py: "bù",
            bihua: "5画",
            wx: "水",
            source: "布姓的来源可能与古代的织布业或布匹贸易有关，也可能与古代的官职、地名或人物有关。",
            py2: "bu"
        },
        {
            name: "衣",
            py: "yī",
            bihua: "6画",
            wx: "土",
            source: "衣姓的起源可能与古代的官职、地名或人物有关，但目前尚缺乏确切的历史资料来证实其起源。",
            py2: "yi"
        },
        {
            name: "来",
            py: "lái",
            bihua: "7画",
            wx: "火",
            source: "来姓的起源有多种说法，其中一种是源于子姓，出自商朝莱侯之后裔，以国名为氏。另一种说法是源于虞姓，出自古代舜帝的后代遏父，属于以国名为氏。",
            py2: "lai"
        },
        {
            name: "恒",
            py: "héng",
            bihua: "9画",
            wx: "水",
            source: "恒姓的起源目前尚不十分明确，可能源于古代的官职、地名或人物。恒字在汉字中表示持久、长久，可能反映了恒姓族群的某些特质或历史背景。",
            py2: "heng"
        },
        {
            name: "那",
            py: "nuó，nā",
            bihua: "6画",
            wx: "金",
            source: "那姓源于春秋时期，以地名为姓。也有满族、蒙古、回族等那姓。南北朝时期，代北鲜卑族拓拔部中原来就有那氏，在北魏孝文帝于太和十七至二十年迁都洛阳入主中原之后，汉化后依旧称那氏，后融入汉族，世代相传至今。",
            py2: "na"
        },
        {
            name: "门",
            py: "mén",
            bihua: "3画",
            wx: "水",
            source: "门字的基本解释是建筑物的出入口，又指安装在出入口能开关的装置。作为姓氏，其来源可能与古代的门官、门卫或守门的职业有关。",
            py2: "men"
        },
        {
            name: "皋",
            py: "gāo",
            bihua: "8画",
            wx: "木",
            source: "皋姓出自远古东夷部落少昊氏族皋陶氏之后，属于以先祖名字为氏。皋陶是黄帝之子少昊之后，又名咎繇，是古代东夷部落少昊氏族的首领。",
            py2: "gao"
        },
        {
            name: "旺",
            py: "wàng",
            bihua: "8画",
            wx: "土",
            source: "旺字的基本解释是兴盛、盛，如旺年（水果等丰收的年份，俗称“大年”）。作为姓氏，其来源目前尚不十分明确。",
            py2: "wang"
        },
        {
            name: "公",
            py: "gōng",
            bihua: "4画",
            wx: "木",
            source: "公姓源流单纯，源出有四。常用的说法是出自姬姓，起源于上古，以爵号为氏。公姓在全国的分布以山东蒙阴居多。",
            py2: "gong"
        },
        {
            name: "言",
            py: "yán",
            bihua: "7画",
            wx: "木",
            source: "言姓的取名数理吉凶为吉。言字在汉字中有多重含义，如说话、言论等，可能反映了言姓族群的某些特质或历史背景。",
            py2: "yan"
        },
        {
            name: "藤",
            py: "téng",
            bihua: "18画",
            wx: "木",
            source: "藤姓是一个较为罕见的姓氏，出自《万姓统谱》。藤姓在全国的人口数量约为6万，主要分布于江苏、浙江、山东、四川等地。",
            py2: "teng"
        },
        {
            name: "释",
            py: "shì",
            bihua: "12画",
            wx: "金",
            source: "释姓的起源与佛教有关，很多佛教僧侣都使用释作为姓氏，以表示他们皈依佛教、脱离尘世的决心。此外，释姓也可能源于古代的官职或地名。",
            py2: "shi"
        },
        {
            name: "尧",
            py: "yáo",
            bihua: "6画",
            wx: "木",
            source: "尧姓的起源与上古时期的尧帝有关，尧帝是传说中的贤明君主，因此其后代或敬仰尧帝的人可能以尧为姓。",
            py2: "yao"
        },
        {
            name: "阚",
            py: "kàn",
            bihua: "14画",
            wx: "木",
            source: "阚姓是一个较为罕见的姓氏，出自姜姓。",
            py2: "kan"
        },
        {
            name: "靖",
            py: "jìng",
            bihua: "13画",
            wx: "金",
            source: "靖姓有多个起源，主要源于姬姓，出自西周王朝公族单靖公之后，也有部分源于妫姓和满族。",
            py2: "jing"
        },
        {
            name: "渠",
            py: "qú",
            bihua: "11画",
            wx: "水",
            source: "渠姓是一个常见的姓氏，其来源可能与古代的水渠、河流等地理环境有关。",
            py2: "qu"
        },
        {
            name: "契",
            py: "qi xing",
            bihua: "9画",
            wx: "木",
            source: "契姓出自中国古代的契苾族，这是一个以族称为源的复姓，后来慢慢演变成了单姓契。契姓也有融入回族的情况。",
            py2: "qi"
        },
        {
            name: "晋",
            py: "jìn",
            bihua: "10画",
            wx: "火",
            source: "晋姓是一个古老的汉族贵族姓氏，源于姬姓，出自周武王之子叔虞的封地，属于以国名为氏。",
            py2: "jin"
        },
        {
            name: "六",
            py: "lù",
            bihua: "8画",
            wx: "火",
            source: "六姓主要分布在湖北、安徽等地，其起源和具体含义目前尚不十分明确。",
            py2: "lu"
        },
        {
            name: "良",
            py: "liáng",
            bihua: "7画",
            wx: "火",
            source: "良姓是一个常见的姓氏，其起源和含义可能与古代的道德观念、品质评价等有关。",
            py2: "liang"
        },
        {
            name: "势",
            py: "shì",
            bihua: "8画",
            wx: "金",
            source: "势姓是一个比较少见的姓氏，其起源和含义目前尚不十分明确。",
            py2: "shi"
        },
        {
            name: "竺",
            py: "zhú",
            bihua: "8画",
            wx: "木",
            source: "竺姓的起源可能与古代的竹有关，也可能与古代的地名、官职或人物有关。",
            py2: "zhu"
        },
        {
            name: "扬",
            py: "yáng",
            bihua: "6画",
            wx: "火",
            source: "扬姓是一个常见的姓氏，其来源可能与古代的扬起、发扬等动作或意义有关，也可能与古代的地名、官职或人物有关。",
            py2: "yang"
        },
        {
            name: "励",
            py: "lì",
            bihua: "7画",
            wx: "火",
            source: "励姓有两个主要来源。一是相传源于姬姓，出自商王太庚给一姬姓英雄的赐姓，属于帝王赐姓改姓为氏。另一来源是出自商朝时期厉国，属于以国名为氏。",
            py2: "li"
        },
        {
            name: "归",
            py: "guī",
            bihua: "5画",
            wx: "木",
            source: "归姓源于少昊之子，归姓名人有归登、归有光、归庄等。归有光（1507-1571），明代昆山（今属江苏省）人，人称震川先生。",
            py2: "gui"
        },
        {
            name: "荃",
            py: "quán",
            bihua: "9画",
            wx: "木",
            source: "荃字是一个较为常见的汉字，但其作为姓氏的起源和具体含义目前尚不十分明确。",
            py2: "quan"
        },
        {
            name: "焉",
            py: "yān",
            bihua: "11画",
            wx: "土",
            source: "焉姓的起源目前尚不十分明确，可能源于古代的某种地名、官职或人物。在百家姓排名中，焉姓的排名在不同时间有所变动，但总体较为靠后。",
            py2: "yan"
        },
        {
            name: "多",
            py: "duō",
            bihua: "6画",
            wx: "火",
            source: "多姓是一个较为罕见的姓氏，其起源和含义目前尚不十分明确。在汉字中，多字有多重含义，如数量大、超出原有或应有的数目等，可能与多姓的起源和含义有关。",
            py2: "duo"
        },
        {
            name: "果",
            py: "guǒ",
            bihua: "8画",
            wx: "木",
            source: "果姓源于妫姓，出自西汉末期汉元帝皇后王政君之族，属于避难改姓为氏。主要分布在今湖北省天门市、黑龙江省齐齐哈尔市、山东省菏泽市等地。果姓的名人有果盛寿等。",
            py2: "guo"
        },
        {
            name: "隆",
            py: "lóng",
            bihua: "11画",
            wx: "火",
            source: "隆姓在宋版《百家姓》中排第368位，其起源和含义目前尚不十分明确。",
            py2: "long"
        },
        {
            name: "礼",
            py: "lǐ",
            bihua: "5画",
            wx: "火",
            source: "礼姓作为一个姓氏，其起源和具体含义目前尚不十分明确。在汉字中，礼字有多重含义，如表示尊敬的态度和动作、礼节、规矩等，可能与礼姓的起源和含义有关。",
            py2: "li"
        },
        {
            name: "强",
            py: "qiáng",
            bihua: "12画",
            wx: "木",
            source: "强姓有多个起源说法，如强姓来自禺疆的后代、强鉏的后代、公孙强的后代等。在宋版《百家姓》中，强姓排名第136位。",
            py2: "qiang"
        },
        {
            name: "麻",
            py: "má",
            bihua: "11画",
            wx: "水",
            source: "麻姓主要分布在河南项城、浙江缙云、河北尚义等地，其始祖为麻婴。",
            py2: "ma"
        },
        {
            name: "钟",
            py: "zhōng",
            bihua: "9画",
            wx: "金",
            source: "钟姓有多个来源，其中一个来源是西汉时期甘肃临洮的钟羌，他们以族名汉字音译为姓。另一个来源是满族宗佳氏、周佳氏等汉化改姓为钟氏。",
            py2: "zhong"
        },
        {
            name: "刁",
            py: "diāo",
            bihua: "2画",
            wx: "火",
            source: "刁字的本意为古代行军用具，作为姓氏，其起源尚未明确。",
            py2: "diao"
        },
        {
            name: "汲",
            py: "jí",
            bihua: "6画",
            wx: "水",
            source: "汲姓的起源目前尚不十分明确。",
            py2: "ji"
        },
        {
            name: "靳",
            py: "jìn",
            bihua: "13画",
            wx: "木",
            source: "靳姓出自芈姓，战国时期楚国大夫靳尚为得姓始祖。靳姓在今中国大陆百家姓中排名第168位。",
            py2: "jin"
        },
        {
            name: "山",
            py: "shān",
            bihua: "3画",
            wx: "土",
            source: "山姓起源于周朝掌管山林的官员叫山师，子孙以官为氏，后演化为山姓。",
            py2: "shan"
        },
        {
            name: "储",
            py: "chǔ",
            bihua: "12画",
            wx: "金",
            source: "储姓源于上古有储国，国人以地名为姓，形成储姓。此外，春秋时期有储子，其后代亦以储为姓。",
            py2: "chu"
        },
        {
            name: "隗",
            py: "wěi",
            bihua: "11画",
            wx: "土",
            source: "隗姓有两个主要来源。一是商朝时，汤灭桀后，封夏朝王族的后代到隗邑，后代以封地为姓，形成隗姓。二是春秋时期，赤狄族中有隗姓。",
            py2: "wei"
        },
        {
            name: "羿",
            py: "yì",
            bihua: "9画",
            wx: "木",
            source: "羿姓源于夏朝著名的弓箭手后羿的后代，他们以祖先的名字为姓。",
            py2: "yi"
        },
        {
            name: "牧",
            py: "mù",
            bihua: "8画",
            wx: "水",
            source: "牧姓是黄帝时期大臣力牧的后代，力牧曾帮助黄帝治理天下立下大功，其后代中有以牧为姓的。历史上牧姓人物众多，如唐代文学家牧相、清代画家牧远等。",
            py2: "mu"
        },
        {
            name: "芮",
            py: "ruì",
            bihua: "7画",
            wx: "火",
            source: "芮姓起源于周武王封姬姓司徒于芮（今陕西大荔南）建芮国，世称芮伯。春秋时，芮国被晋献公所灭，子孙后代为纪念先祖改姓芮。",
            py2: "rui"
        },
        {
            name: "弓",
            py: "gōng",
            bihua: "3画",
            wx: "木",
            source: "弓姓出自姬姓，以王父字为氏。据《万姓统谱》记载，鲁国公孙婴齐曾随鲁成公伐宋、郑二国立大功受封世代为鲁国大夫，婴齐孙叔弓，其支孙取王父之字中的“弓”为氏。",
            py2: "gong"
        },
        {
            name: "封",
            py: "fēng",
            bihua: "9画",
            wx: "水",
            source: "封姓源于姜姓。",
            py2: "feng"
        },
        {
            name: "巴",
            py: "bā",
            bihua: "4画",
            wx: "水",
            source: "巴姓源出有四，其中之一是出自风姓，以水为姓；另一说是出自姬姓，以国为姓。",
            py2: "ba"
        },
        {
            name: "焦",
            py: "jiāo",
            bihua: "12画",
            wx: "火",
            source: "焦姓中的一些族人认为他们的姓氏出自西南夷，是文化上汉化改姓的结果。这可能与先秦时期楚文化的影响有关。",
            py2: "jiao"
        },
        {
            name: "曲",
            py: "qū",
            bihua: "6画",
            wx: "木",
            source: "曲姓的来源有多种说法，一些史料上说是出自曲沃桓叔，也有些曲姓族人认为自己源自鞠姓。无论源自何处，曲姓都是地道的黄帝后裔，其根源都可以追溯到周文王。",
            py2: "qu"
        },
        {
            name: "姓",
            py: "xìng",
            bihua: "8画",
            wx: "金",
            source: "“姓”字始见于商代甲骨文，古字形从女从生，生亦表声。姓本是整个氏族的称号，表明一种血缘关系，留有母系氏族社会的痕迹。后来，“姓”被用作动词，指以……为姓，并且逐渐用来指官吏、平民，例如“百姓”即百官，也可指老百姓；平民的含义一直保留到现代。",
            py2: "xing"
        },
        {
            name: "溥",
            py: "pǔ",
            bihua: "13画",
            wx: "水",
            source: "溥是一个汉字，其拼音为pǔ，但作为一个姓氏，其具体的出处和来源可能不太常见。它可能源于古代的某个地名、官职名或者人名，但由于历史资料的缺失或难以考证，目前无法确定其确切的出处。",
            py2: "pu"
        },
        {
            name: "卻",
            py: "què",
            bihua: "9画",
            wx: "火",
            source: "卻字在古汉语中同“却”，其作为姓氏的出处并不明确，可能源于古代的某个地名、官职名或者人名。具体的历史来源需要进一步研究和考证。",
            py2: "que"
        },
        {
            name: "蔚",
            py: "yù",
            bihua: "14画（蔚字本身为14画，作为姓氏的笔画数相同）",
            wx: "木",
            source: "蔚姓属于“以邑为氏”，起源于蔚州，祖宗为公子翩。得姓始祖为公子翩。",
            py2: "yu"
        },
        {
            name: "辛",
            py: "xīn",
            bihua: "7画",
            wx: "金",
            source: "辛姓是一个常见的姓氏，其来源有多个说法。其中一个说法是辛姓源于姒姓，由夏朝大臣辛甲的后代开始。辛姓在中国历史上有很多著名的人物，如辛弃疾等。",
            py2: "xin"
        },
        {
            name: "訾",
            py: "zī",
            bihua: "8画（简体）",
            wx: "金",
            source: "訾姓是一个非常古老的姓氏，其来源有多种说法。其中一种说法是訾姓源于夏朝诸侯国中的皆陬国，后来以国名省文简化为訾姓。另一种说法是訾姓出自祭氏所改。",
            py2: "zi"
        },
        {
            name: "冷",
            py: "lěng",
            bihua: "7画",
            wx: "水",
            source: "冷姓的来源并不十分明确，作为一个姓氏，它可能源于古代某个地名、官职名或者人名。冷姓在中国历史上也有一定的分布和代表人物。",
            py2: "leng"
        },
        {
            name: "欧",
            py: "ōu",
            bihua: "8画（简体）；15画（繁体）",
            wx: "土",
            source: "欧字古同“讴”，意为歌唱。作为姓氏，其具体来源可能涉及多方面的历史和文化背景，但目前无法给出确切的出处。",
            py2: "ou"
        },
        {
            name: "融",
            py: "róng",
            bihua: "简体和繁体均为16画",
            wx: "未特定（通常不直接确定姓氏的五行属性）",
            source: "融姓源流单纯，主要源于高阳氏，出自颛顼帝高阳氏的后代祝融，属于以先祖名字为氏。",
            py2: "rong"
        },
        {
            name: "敖",
            py: "áo",
            bihua: "10画（简体和繁体）",
            wx: "土",
            source: "敖字的基本解释中有出游、闲游的含义。作为姓氏，其具体来源可能涉及多方面的历史和文化背景，但目前无法给出确切的出处。",
            py2: "ao"
        },
        {
            name: "勾",
            py: "gōu",
            bihua: "简体4画，繁体5画",
            wx: "木",
            source: "勾姓有多个来源。一是源于黄帝的太玄孙句芒（勾芒）；二是源于炎帝的太玄孙（五世孙）句龙（勾龙）；三是源于春秋晚期卫国贵族句井疆，属于以先祖名字为氏。",
            py2: "gou"
        },
        {
            name: "晁",
            py: "cháo",
            bihua: "10画（简体）",
            wx: "未特定（通常不直接确定姓氏的五行属性）",
            source: "晁是一个姓氏，但关于其具体的来源和出处，目前并没有明确的历史资料可以追溯。",
            py2: "chao"
        },
        {
            name: "聂",
            py: "niè",
            bihua: "简体10画，繁体18画",
            wx: "未特定（通常不直接确定姓氏的五行属性）",
            source: "聂字的本义为附耳小语。作为姓氏，聂姓的来源可能涉及古代的历史事件或文化背景，但目前无法给出确切的出处。",
            py2: "nie"
        },
        {
            name: "厍",
            py: "shè",
            bihua: "6画",
            wx: "未特定（通常不直接确定姓氏的五行属性）",
            source: "厍是一个汉语二级字，在方言中，它常用来表示村庄，同时也是一个姓氏。关于其作为姓氏的具体出处，目前并没有详细的历史资料可以追溯。",
            py2: "she"
        },
        {
            name: "巩",
            py: "gǒng",
            bihua: "简体6画，繁体15画",
            wx: "金",
            source: "巩姓源于姬姓，是以地为氏的。据《姓氏急就篇》记载，巩氏是周朝大夫食采于巩，因此以巩为氏。",
            py2: "gong"
        },
        {
            name: "师",
            py: "shī",
            bihua: "简体6画，繁体7画",
            wx: "金",
            source: "师姓是中华民族古老的姓氏之一，产生于远古时期，是一个多民族、多源流的姓氏。关于师姓的具体出处，有多种不同的说法，但都无法确定其确切的起源。",
            py2: "shi"
        },
        {
            name: "夔",
            py: "kuí",
            bihua: "简体8画，繁体15画",
            wx: "木",
            source: "夔姓的得姓始祖是尧帝和舜帝的乐官夔。夔在古代是音乐家的意思，也是传说中一种形状像龙而只有一足的动物。",
            py2: "kui"
        },
        {
            name: "越",
            py: "yuè",
            bihua: "简体9画，繁体12画",
            wx: "土",
            source: "越姓出自姒姓，为春秋时越王勾践之后，属于以国为氏。据《国语·贾逵注》记载，越氏出自夔姓和华姓，实际上是夏王朝王族的苗裔，夏帝少康的庶子被封于会稽（今浙江绍兴），自号为越国，他的后代以国为氏，望族出于晋阳。",
            py2: "yue"
        },
        {
            name: "查",
            py: "chá/zhā",
            bihua: "简体9画，繁体10画",
            wx: "金",
            source: "查姓的起源较为复杂，异体字为“査”，部首为“木”，部首笔画为4画。在康熙字典中，查字的笔画数为9画，五行属性为金。作为一个姓氏，其具体出处可能涉及多方面的历史和文化背景，但目前无法给出确切的起源。",
            py2: "cha"
        },
        {
            name: "蒯",
            py: "kuǎi",
            bihua: "简体13画，繁体16画",
            wx: "木",
            source: "《左传·成公九年》中提到“蒯草，虽有丝麻，无弃菅蒯”，表明蒯字在古代文献中已有出现。作为姓氏，蒯姓的起源可能与古代的草名“蒯”有关，但具体出处需要进一步研究历史资料来确认。",
            py2: "kuai"
        },
        {
            name: "关",
            py: "guān",
            bihua: "简体6画，繁体9画（作为姓氏的繁体字形）",
            wx: "木",
            source: "关姓有多个著名历史人物，如武圣关羽、五代后梁画家关仝、宋代太学博士关景仁等。关姓的起源可能涉及多个方面，包括以地名为姓、以官职为姓等，但具体出处需要依据历史文献进行深入研究。",
            py2: "guan"
        },
        {
            name: "桓",
            py: "huán",
            bihua: "简体9画，繁体10画",
            wx: "木",
            source: "桓姓有多个来源，其中一些可以追溯到古代的桓公或桓常等历史人物。桓姓在中国历史上也有其独特的地位和贡献，但关于其具体的出处和起源，还需要进一步的历史研究来揭示。",
            py2: "huan"
        },
        {
            name: "益",
            py: "yì",
            bihua: "简体5画，繁体10画",
            wx: "土",
            source: "益姓源出有三，其中之一是源于嬴姓，但关于益姓的具体出处和起源，目前并没有明确的历史资料可以追溯。益字在古代有增加、利益等含义，可能与益姓的起源有关，但这需要进一步的历史研究来证实。",
            py2: "yi"
        },
        {
            name: "鞠",
            py: "jū",
            bihua: "简体17画，繁体17画",
            wx: "木",
            source: "鞠字在古代的本义为踢打玩耍的皮球，后来演化为姓氏。鞠姓的起源可能与鞠字的本义或相关历史事件有关，但具体出处需要进一步的历史研究来确认。",
            py2: "ju"
        },
        {
            name: "盍",
            py: "hé",
            bihua: "简体10画，繁体9画",
            wx: "水",
            source: "盍字在古汉语中有何不、表示反问或疑问的含义。作为姓氏，盍姓的起源可能与其字义或相关历史事件有关，但具体出处需要进一步的历史研究来揭示。",
            py2: "he"
        },
        {
            name: "养",
            py: "yǎng",
            bihua: "简体9画，繁体9画",
            wx: "土",
            source: "养姓得姓始祖所在地在今天的河南省沈丘县的东方，得姓已有2400年以上的历史。",
            py2: "yang"
        },
        {
            name: "逮",
            py: "dài 或 lù",
            bihua: "简体11画，繁体11画",
            wx: "未特定（通常不直接确定姓氏的五行属性）",
            source: "逮姓源自古代的官职称谓或秦汉之际的通假字。在秦汉之际，“逯”、“逮”二字通义通假，因此逯氏亦称逮氏。",
            py2: "dai"
        },
        {
            name: "乜",
            py: "miē 或 niè",
            bihua: "简体6画，繁体6画",
            wx: "未特定（通常不直接确定姓氏的五行属性）",
            source: "乜姓是一个姓氏，读作niè。关于其具体的出处和起源，目前并没有明确的历史资料可以追溯。",
            py2: "mie"
        },
        {
            name: "权",
            py: "quán",
            bihua: "简体6画，繁体6画",
            wx: "木",
            source: "权姓源于子姓，是一个具有悠久历史的姓氏。关于其具体的出处和起源，还需要进一步的历史研究来揭示。",
            py2: "quan"
        },
        {
            name: "沙",
            py: "shā",
            bihua: "简体7画，繁体7画",
            wx: "水",
            source: "沙姓中的“沙”字基本解释为非常细碎的石粒，也可能作为地名或其他含义。作为姓氏，沙姓的具体出处需要进一步研究历史资料来确认。",
            py2: "sha"
        },
        {
            name: "毋",
            py: "wú 或 guàn",
            bihua: "简体4画，繁体5画",
            wx: "未特定（通常不直接确定姓氏的五行属性）",
            source: "毋姓有两个主要来源，一是出自上古尧帝臣子毋句之后，以祖名为氏；二是出自田姓所改，以封地名为氏。",
            py2: "wu"
        },
        {
            name: "游",
            py: "yóu",
            bihua: "简体12画，繁体12画",
            wx: "水",
            source: "游姓是一个常见的姓氏，其来源可能涉及多方面的历史和文化背景，但目前无法给出确切的出处。",
            py2: "you"
        },
        {
            name: "曾",
            py: "zēng",
            bihua: "简体12画，繁体12画",
            wx: "金",
            source: "曾姓的来源有多个，其中一个主要的来源是姒姓，为夏禹的后裔。",
            py2: "zeng"
        },
        {
            name: "红",
            py: "hóng",
            bihua: "简体6画，繁体6画",
            wx: "水",
            source: "红姓主要源于芈姓，出自春秋时期楚国公族子孙，属于以先祖名字为氏。也有部分红姓源于祁姓。",
            py2: "hong"
        },
        {
            name: "空",
            py: "kōng",
            bihua: "简体8画，繁体8画",
            wx: "木",
            source: "空姓的来源目前无法确定，可能涉及多方面的历史和文化背景，需要进一步的研究和考证。",
            py2: "kong"
        },
        {
            name: "荆",
            py: "jīng",
            bihua: "简体9画，繁体9画",
            wx: "水",
            source: "荆姓是一个常见的姓氏，其来源和出处可能涉及多方面的历史和文化因素，目前无法给出确切的出处。",
            py2: "jing"
        },
        {
            name: "饶",
            py: "ráo",
            bihua: "简体9画，繁体9画",
            wx: "木",
            source: "饶姓主要源自姜姓和妫姓。饶姓在历史上的分布和名人事迹也是其出处的重要参考。",
            py2: "rao"
        },
        {
            name: "后",
            py: "hòu",
            bihua: "简体6画，繁体9画",
            wx: "水",
            source: "后姓有多个来源。一部分源自上古东邑部族首领太昊的孙子后照的后代；另一部分传说炎帝后代共工氏有子名叫句龙，在黄帝时担任后土，其后代就以官名的一字为姓，称为后氏；还有西周时鲁孝公的儿子公子巩的封邑为郈，他的后代以邑名为氏，称为郈姓，后来省去右边的邑旁为后氏，称后姓。",
            py2: "hou"
        },
        {
            name: "简",
            py: "jiǎn",
            bihua: "简体8画，繁体13画",
            wx: "木",
            source: "简姓是黄帝子孙，姬族后裔。据《范阳简氏家谱》记载，简姓的始祖是晋大夫狐鞫居，食邑于续，谥号续简子，世称续简伯，他的子孙以其谥号为氏。",
            py2: "jian"
        },
        {
            name: "朴",
            py: "piáo",
            bihua: "简体6画",
            wx: "木",
            source: "中国朴姓最早起源于东汉时期的益州（大致相当于今天的四川省）巴郡。《三国志·魏志》中有记载：“建安二十年，巴夷王朴胡，举巴夷来附。”这表明朴姓至少在东汉末年已有历史记载，并且与巴蜀地区有关联。",
            py2: "piao"
        },
        {
            name: "姒",
            py: "sì",
            bihua: "简体6画",
            wx: "金",
            source: "姒姓起源于大禹，黄帝母族有蟜氏、有崇氏（鲧之封国）、夏后氏（大禹之国）、有莘氏、杞氏等国（部落）以及周文王之妻太姒、周幽王之后褒姒均为姒姓。",
            py2: "si"
        },
        {
            name: "嬴",
            py: "yíng",
            bihua: "简体10画",
            wx: "木",
            source: "嬴姓起源于皋陶，皋陶生于曲阜，因而以嬴为姓。秦、赵、徐、江、黄、葛、梁、郯等许多古代部族和国家都出自嬴姓。",
            py2: "ying"
        },
        {
            name: "妘",
            py: "yún",
            bihua: "简体9画",
            wx: "水",
            source: "妘姓起源于祝融氏，祝融之后，为己、董、彭、秃、妘、曹、斟、芈等许多氏族，这些氏族后来分化出众多姓氏。",
            py2: "yun"
        },
        {
            name: "妫",
            py: "guī",
            bihua: "简11画",
            wx: "火",
            source: "妫姓源自虞舜，即上古时期五帝之一的舜帝，其后裔以妫为姓。舜帝的后代建立了陈国、齐国等，其后人分支众多，形成了田、陆、车、薛、袁、孙、王、胡等多个姓氏。",
            py2: "gui"
        },
        {
            name: "姞",
            py: "jí",
            bihua: "简体8画",
            wx: "土",
            source: "姞姓源于黄帝之子任姓氏族，姞姓部族曾建立过燕、须句、宿、密等古国。姞姓后裔分化出许多其他姓氏，如燕、吉、雍、鄂、阚、光、杨、孔等。",
            py2: "ji"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/surname.js